const local: App.I18n.Schema = {
    view: {
        grid: "موزائیکی",
        list: "لیست",
        compact: "فشرده",
    },
    support: {
        title: "مرکز پشتیبانی",
        description: "دریافت کمک و مدیریت تیکت‌های پشتیبانی",
        myTickets: "تیکت‌های من",
        createTicket: "ایجاد تیکت",
        agent: "پشتیبان",

        // Navigation
        navigation: {
            dashboard: "داشبورد",
            createTicket: "ایجاد تیکت",
            myTickets: "تیکت‌های من",
            allTickets: "همه تیکت‌ها",
            openTickets: "تیکت‌های باز",
            inProgress: "در حال انجام",
            resolved: "حل شده",
        },

        // Ticket properties
        ticket: {
            subject: "موضوع",
            description: "توضیحات",
            status: "وضعیت",
            priority: "اولویت",
            category: "دسته‌بندی",
            createdAt: "ایجاد شده",
            updatedAt: "به‌روزرسانی شده",
            assignedTo: "اختصاص داده شده به",
            ticketNumber: "شماره تیکت",
            replies: "پاسخ‌ها",
            attachments: "فایل‌های پیوست",
            details: "جزئیات تیکت",
            information: "اطلاعات تیکت",
            createdBy: "ایجاد شده توسط",
            resolvedAt: "حل شده در",
            slaDueAt: "موعد SLA",
            internalNotes: "یادداشت‌های داخلی",
        },

        // Status values
        statuses: {
            open: "باز",
            inProgress: "در حال انجام",
            waitingCustomer: "در انتظار کاربر",
            resolved: "حل شده",
            closed: "بسته شده",
        },

        // Status values (alternative format for compatibility)
        status: {
            open: "باز",
            in_progress: "در حال انجام",
            waiting_customer: "در انتظار کاربر",
            resolved: "حل شده",
            closed: "بسته شده",
        },

        // Priority values
        priorities: {
            low: "کم",
            medium: "متوسط",
            high: "بالا",
            critical: "بحرانی",
        },

        // Priority values (alternative format for compatibility)
        priority: {
            low: "کم",
            medium: "متوسط",
            high: "بالا",
            critical: "بحرانی",
        },

        // Categories
        categories: {
            title: "دسته‌بندی‌های پشتیبانی",
            technical: "مسئله فنی",
            billing: "صورتحساب",
            account: "حساب کاربری",
            feature: "درخواست ویژگی",
            bug: "گزارش باگ",
            other: "سایر",
        },

        // Actions
        actions: {
            create: "ایجاد تیکت",
            reply: "ارسال پاسخ",
            previewReply: "پیش‌نمایش پاسخ",
            attach: "پیوست فایل",
            filter: "فیلتر",
            search: "جستجوی تیکت‌ها...",
            submit: "ارسال",
            cancel: "لغو",
            save: "ذخیره",
            edit: "ویرایش",
            delete: "حذف",
            close: "بستن تیکت",
            reopen: "باز کردن مجدد تیکت",
            closeTicket: "بستن تیکت",
            reopenTicket: "باز کردن مجدد تیکت",
            moreActions: "عملیات بیشتر",
            assign: "اختصاص",
            viewDetails: "مشاهده جزئیات",
            downloadAttachment: "دانلود",
            viewAll: "مشاهده همه",
            back: "بازگشت",
            changeStatus: "تغییر وضعیت",
            changePriority: "تغییر اولویت",
            download: "دانلود",
            searchAll: "جستجو در همه تیکت‌ها...",
            clearFilters: "پاک کردن فیلترها",
            retryNow: "تلاش مجدد",
            refresh: "بروزرسانی",
            ticketsRefreshed: "تیکت‌ها بروزرسانی شدند",
            createTicket: "ایجاد تیکت",
            yes: "بله",
            no: "خیر",
        },

        // پیش‌نمایش پاسخ برای کارشناسان
        preview: {
            title: "پیش‌نمایش پاسخ",
            subtitle: "قبل از ارسال، پاسخ خود را بررسی کنید",
            internalNoteTitle: "پیش‌نمایش یادداشت داخلی",
            replyContent: "متن پاسخ",
            internalReply: "یادداشت داخلی",
            publicReply: "پاسخ عمومی",
            internalNote: "این یک یادداشت داخلی است و فقط برای کارشناسان قابل مشاهده است",
            publicNote: "این پاسخ برای کاربر قابل مشاهده خواهد بود",
            agentsOnly: "فقط کارشناسان",
            characters: "کاراکتر",
            statusChange: "وضعیت تغییر خواهد کرد به",
            currentStatus: "فعلی",
            confirmTitle: "آماده ارسال؟",
            confirmMessage: "لطفاً محتوای بالا را با دقت بررسی کنید. پس از ارسال، این پاسخ برای کاربر قابل مشاهده خواهد بود.",
            confirmMessageInternal: "این یادداشت داخلی فقط برای کارشناسان و تیم پشتیبانی قابل مشاهده است. کاربر این پیام را نخواهد دید.",
            checkContent: "محتوا را از نظر صحت بررسی کرده‌ام",
            checkTone: "لحن پیام حرفه‌ای و مفید است",
            checkCustomerVisible: "می‌دانم که این پاسخ برای کاربر قابل مشاهده خواهد بود",
            edit: "ویرایش پاسخ",
            confirm: "ارسال پاسخ",
            sendInternal: "ارسال یادداشت داخلی",
            escToCancel: "برای لغو کلید Esc را فشار دهید",
        },

        // Forms
        forms: {
            subjectPlaceholder: "موضوع تیکت را وارد کنید",
            descriptionPlaceholder: "مسئله خود را به تفصیل شرح دهید...",
            replyPlaceholder: "پیام خود را وارد کنید...",
            selectCategory: "دسته‌بندی را انتخاب کنید",
            selectPriority: "اولویت را انتخاب کنید",
            fileUpload: "آپلود فایل",
            dragDropFiles: "فایل‌ها را اینجا بکشید و رها کنید یا کلیک کنید",
            maxFileSize: "حداکثر اندازه فایل: {size} مگابایت",
            allowedTypes: "انواع فایل مجاز: {types}",
            useTemplate: "استفاده از قالب",
            selectTemplate: "قالب را انتخاب کنید",
            cannedResponses: "پاسخ‌های آماده",
            selectCannedResponse: "پاسخ آماده را انتخاب کنید",
        },

        // Filters
        filters: {
            title: "فیلترها",
            status: "وضعیت",
            priority: "اولویت",
            category: "دسته‌بندی",
            dateRange: "بازه زمانی",
            assignedTo: "اختصاص داده شده به",
            createdBy: "ایجاد شده توسط",
            clearFilters: "پاک کردن فیلترها",
            applyFilters: "اعمال فیلترها",
            showFilters: "نمایش فیلترها",
            hideFilters: "مخفی کردن فیلترها",
            activeFilters: "فیلترهای فعال",
            search: "جستجو",
            unassigned: "بدون مسئول",
            assignedToMe: "اختصاص داده شده به من",
            assignee: "مسئول",
        },

        // View modes
        viewModes: {
            grid: "نمایش موزائیکی",
            list: "نمایش لیستی",
        },

        // Views
        views: {
            grid: "موزائیک",
            list: "لیست",
        },

        // Sorting
        sorting: {
            newest: "جدیدترین",
            oldest: "قدیمی‌ترین",
            priority: "اولویت",
            status: "وضعیت",
            updated: "به‌روزرسانی شده اخیر",
            createdAt: "تاریخ ایجاد",
            updatedAt: "تاریخ به‌روزرسانی",
            subject: "موضوع",
        },

        // Messages
        messages: {
            noTickets: "تیکت یافت نشد",
            noTicketsDescription: "شما هنوز هیچ تیکت پشتیبانی ایجاد نکرده‌اید.",
            ticketCreated: "تیکت با موفقیت ایجاد شد",
            ticketUpdated: "تیکت با موفقیت به‌روزرسانی شد",
            replyAdded: "پاسخ با موفقیت اضافه شد",
            fileUploaded: "فایل با موفقیت آپلود شد",
            ticketClosed: "تیکت با موفقیت بسته شد",
            ticketReopened: "تیکت با موفقیت باز شد",
            confirmCloseTicket: "آیا مطمئن هستید که می‌خواهید این تیکت را ببندید؟ این کار از پاسخ‌های بیشتر جلوگیری می‌کند تا زمانی که تیکت دوباره باز شود.",
            confirmReopenTicket: "آیا مطمئن هستید که می‌خواهید این تیکت را دوباره باز کنید؟ این کار اجازه می‌دهد پاسخ‌های جدید اضافه شوند.",
            errorClosingTicket: "خطا در بستن تیکت",
            errorReopeningTicket: "خطا در باز کردن مجدد تیکت",
            loadingTickets: "در حال بارگذاری تیکت‌ها...",
            loadingTicket: "در حال بارگذاری جزئیات تیکت...",
            errorLoadingTickets: "خطا در بارگذاری تیکت‌ها",
            errorLoadingTicket: "خطا در بارگذاری جزئیات تیکت",
            errorCreatingTicket: "خطا در ایجاد تیکت",
            errorAddingReply: "خطا در ارسال پاسخ",
            statusUpdated: "وضعیت با موفقیت به‌روزرسانی شد",
            errorUpdatingStatus: "خطا در به‌روزرسانی وضعیت",
            priorityUpdated: "اولویت با موفقیت به‌روزرسانی شد",
            errorUpdatingPriority: "خطا در به‌روزرسانی اولویت",
            ticketAssigned: "تیکت با موفقیت اختصاص داده شد",
            errorAssigningTicket: "خطا در اختصاص تیکت",
            ticketNotFound: "تیکت یافت نشد",
            ticketNotFoundDesc: "تیکت مورد نظر شما وجود ندارد یا شما مجوز مشاهده آن را ندارید.",
            retrySuccess: "عملیات با موفقیت انجام شد",
            retryFailed: "تلاش مجدد ناموفق بود. لطفا دوباره تلاش کنید.",
            resetSuccess: "بازنشانی با موفقیت انجام شد",
            resetFailed: "بازنشانی ناموفق بود. لطفا دوباره تلاش کنید.",
            ticketsRefreshed: "تیکت‌ها با موفقیت به‌روزرسانی شدند",
            loadError: "خطا در بارگذاری داده‌ها. لطفا دوباره تلاش کنید.",
            searchError: "جستجو ناموفق بود. لطفا دوباره تلاش کنید.",
            feedbackError: "خطا در ارسال بازخورد. لطفا دوباره تلاش کنید.",
        },

        // Dashboard
        dashboard: {
            title: "پشتیبانی",
            overview: "نمای کلی",
            myStats: "آمار من",
            recentActivity: "فعالیت‌های اخیر",
            quickActions: "اقدامات سریع",
            totalTickets: "کل تیکت‌ها",
            openTickets: "تیکت‌های باز",
            resolvedTickets: "تیکت‌های حل شده",
            avgResponseTime: "میانگین زمان پاسخ",
        },

        // Ticket details
        ticketDetails: {
            conversation: "مکالمه",
            information: "اطلاعات تیکت",
            createdBy: "ایجاد شده توسط",
            assignedTo: "اختصاص داده شده به",
            lastUpdated: "آخرین به‌روزرسانی",
            timeSpent: "زمان صرف شده",
            slaStatus: "وضعیت SLA",
            onTime: "به موقع",
            overdue: "عقب افتاده",
            dueIn: "موعد در {time}",
        },

        // Message and reply types
        message: {
            original: "پیام اصلی",
        },

        replyType: {
            public: "عمومی",
            internal: "داخلی",
        },

        // Reply form labels
        reply: {
            type: "نوع پاسخ",
            public: "پاسخ عمومی",
            internal: "یادداشت داخلی",
        },

        // Replies section
        replies: {
            title: "پاسخ‌ها",
            add: "افزودن پاسخ",
        },

        // Attachments section
        attachments: {
            title: "فایل‌های پیوست",
        },

        // Knowledge Base
        knowledgeBase: {
            needHelp: "نیاز به راهنمایی دارید؟",
            title: "پایگاه دانش",
            articles: "مقالات",
            popularArticles: "مقالات محبوب",
            views: "بازدید",
            helpful: "مفید",
            noArticles: "مقاله‌ای یافت نشد",
            noArticlesDesc: "در حال حاضر هیچ مقاله‌ای موجود نیست.",
            noArticlesInCategory: "این دسته‌بندی هنوز هیچ مقاله‌ای ندارد.",
            stillNeedHelp: "هنوز به کمک نیاز دارید؟",
            wasHelpful: "آیا این مقاله مفید بود؟",
            yes: "بله",
            no: "خیر",
            thanksFeedback: "از بازخورد شما متشکریم!",
            sorryNotHelpful: "متاسفیم که مفید نبود. لطفا برای کمک بیشتر با پشتیبانی تماس بگیرید.",
            searchPlaceholder: "جستجوی مقالات...",
            browseByCategory: "مرور بر اساس دسته‌بندی",
            searchResults: "نتایج جستجو",
            noResults: "نتیجه‌ای یافت نشد",
            noResultsDesc: "هیچ مقاله‌ای با جستجوی شما مطابقت نداشت. کلمات کلیدی دیگری را امتحان کنید.",
        },

        // File upload
        fileUpload: {
            selectFiles: "انتخاب فایل‌ها",
            uploadFiles: "آپلود فایل‌ها",
            uploading: "در حال آپلود...",
            uploadComplete: "آپلود کامل شد",
            uploadFailed: "آپلود ناموفق",
            removeFile: "حذف فایل",
            fileSize: "اندازه فایل",
            fileName: "نام فایل",
            errors: {
                fileTooLarge: "فایل بیش از حد بزرگ است. حداکثر اندازه {maxSize} است",
                invalidFileType: "نوع فایل نامعتبر است",
                fileAlreadyAdded: "فایل قبلا اضافه شده است"
            },
            messages: {
                uploadSuccess: "{count} فایل با موفقیت آپلود شد",
                uploadFailed: "{count} فایل آپلود نشد",
                uploadError: "خطا در آپلود فایل"
            }
        },

        // Polling
        polling: {
            maxRetriesExceeded: "حداکثر تعداد تلاش مجدد به پایان رسید. نظرسنجی متوقف شد.",
            fetchError: "خطا در دریافت داده‌ها",
            tooManyRequests: "تعداد درخواست بیش از حد مجاز",
            tooManyRequestsDesc: "تعداد درخواست‌ها از حد مجاز فراتر است، لطفا پس از چند لحظه دوباره تلاش کنید.",
        },

        // Errors
        errors: {
            networkError: "خطای شبکه",
            permissionError: "عدم دسترسی",
            notFoundError: "یافت نشد",
            genericError: "خطایی رخ داده است",
            timeoutError: "زمان درخواست تمام شد",
            serverError: "خطای سرور",
            maintenanceError: "در حال تعمیر و نگهداری",
            networkErrorDesc: "عدم اتصال به سرور. لطفا اتصال اینترنت خود را بررسی کرده و دوباره تلاش کنید.",
            permissionErrorDesc: "شما مجوز دسترسی به این منبع را ندارید. لطفا با مدیر سیستم تماس بگیرید.",
            notFoundErrorDesc: "منبع درخواستی یافت نشد.",
            genericErrorDesc: "خطایی در بارگذاری داده‌ها رخ داده است. لطفا دوباره تلاش کنید.",
            timeoutErrorDesc: "درخواست بیش از حد طول کشید. لطفا دوباره تلاش کنید.",
            serverErrorDesc: "سرور با خطا مواجه شد (502). لطفا بعدا دوباره تلاش کنید یا در صورت ادامه مشکل با پشتیبانی تماس بگیرید.",
            maintenanceErrorDesc: "سیستم در حال تعمیر و نگهداری است. لطفا بعدا دوباره تلاش کنید.",
            withErrorCode: "{message} (خطا: {code})",
            tryAgain: "تلاش دوباره",
            contactSupport: "تماس با پشتیبانی",
        },

        // Auth required
        authRequired: {
            title: "احراز هویت لازم است",
            description: "لطفا وارد شوید تا بتوانید به سیستم پشتیبانی دسترسی داشته باشید و تیکت‌هایتان را مدیریت کنید.",
            loginButton: "ورود",
        },

        // Empty states
        emptyStates: {
            noTickets: {
                title: "تیکت یافت نشد",
                description: "اولین تیکت پشتیبانی خود را ایجاد کنید.",
                action: "ایجاد تیکت",
            },
            noReplies: {
                title: "هنوز پاسخی نیست",
                description: "اولین نفری باشید که به این تیکت پاسخ می‌دهد.",
            },
            noAttachments: {
                title: "فایل پیوستی نیست",
                description: "هیچ فایلی به این تیکت پیوست نشده است.",
            },
            noSearchResults: {
                description: "سعی کنید عبارت جستجو یا فیلترهای خود را تغییر دهید.",
            },
            noData: {
                description: "داده‌ای در دسترس نیست.",
            },
        },

        // Validation
        validation: {
        subjectRequired: "موضوع ضروری است",
        descriptionRequired: "توضیحات ضروری است",
        categoryRequired: "لطفا دسته‌بندی را انتخاب کنید",
        priorityRequired: "لطفا اولویت را انتخاب کنید",
        fileTooBig: "فایل {fileName} بیش از حد بزرگ است. حداکثر اندازه {size}MB",
        tooManyFiles: "تعداد فایل‌ها زیاد است. حداکثر {max} فایل",
        invalidFileType: "فایل {fileName} نوع نامعتبری دارد. انواع مجاز: {allowedTypes}",
        maxFilesExceeded: "تعداد فایل‌ها از حد مجاز بیشتر است",
        formErrors: "لطفا خطاهای فرم را قبل از ارسال رفع کنید",
        replyRequired: "محتوای پاسخ ضروری است",
        // Dynamic field validation
        fieldRequired: "فیلد {field} ضروری است",
        invalidCardNumber: "شماره کارت نامعتبر است",
        invalidIBAN: "شماره شبا نامعتبر است",
        invalidNumber: "عدد وارد شده نامعتبر است",
        numberTooSmall: "عدد باید حداقل {min} باشد",
        numberTooLarge: "عدد نباید بیش از {max} باشد",
        invalidDate: "تاریخ وارد شده نامعتبر است",
        invalidEmail: "آدرس ایمیل نامعتبر است",
        textTooShort: "متن باید حداقل {min} کاراکتر باشد",
        textTooLong: "متن نباید بیش از {max} کاراکتر باشد",
        invalidFormat: "فرمت وارد شده نامعتبر است",
        invalidOption: "گزینه انتخاب شده نامعتبر است",
        addressRequired: "انتخاب آدرس الزامی است",
        invalidAddress: "آدرس انتخاب شده نامعتبر است",
        },

        // Help section
        help: {
            beforeCreating: "قبل از ایجاد تیکت",
            searchKnowledge: "برای پاسخ سریع به سوالات رایج، پایگاه دانش ما را جستجو کنید.",
            tips: "نکاتی برای پشتیبانی بهتر",
            tip1: "در مورد مسئله خود دقیق باشید و جزئیات مربوطه را شامل کنید",
            tip2: "تصاویر یا فایل‌هایی که به توضیح مسئله کمک می‌کنند، پیوست کنید",
            tip3: "دسته‌بندی و اولویت صحیح را برای حل سریع‌تر انتخاب کنید",
            urgentIssues: "مسائل فوری",
            urgentContact: "برای مسائل بحرانی که نیاز به توجه فوری دارند، مستقیما با تیم پشتیبانی ما تماس بگیرید.",
            contactSupport: "تماس با پشتیبانی",
        },

        // Stats for agent dashboard
        stats: {
            total: "کل",
            unassigned: "بدون مسئول",
            assignedToMe: "اختصاص داده شده به من",
            open: "باز",
            inProgress: "در حال بررسی",
            overdue: "عقب‌افتاده",
            openTickets: "تیکت‌های باز",
        },

        // Agent Dashboard
        agentDashboard: {
            title: "داشبورد پشتیبان",
            viewAllTickets: "مشاهده همه تیکت‌ها",
            myQueue: "صف من",
            unassignedQueue: "صف بدون مسئول",
            ticketsNeedingAttention: "تیکت‌های نیازمند توجه",
        },

        // Role labels
        roles: {
            agent: "پشتیبان",
            admin: "مدیر",
            user: "کاربر",
        },

        // Access denied
        accessDenied: {
            title: "دسترسی غیرمجاز",
            agentRequired: "برای دسترسی به این صفحه نیاز به دسترسی پشتیبان یا مدیر دارید.",
        },

        // All Tickets view
        allTickets: "همه تیکت‌ها",

        // Agent actions
        agentActions: {
            title: "عملیات پشتیبان",
            noAgentsAvailable: "پشتیبانی در دسترس نیست",
            assignToMe: "اختصاص به من",
            unassign: "لغو اختصاص",
        },

        // Bulk Actions
        bulkActions: {
            selectedCount: "{count} تیکت انتخاب شده",
            changeStatus: "تغییر وضعیت",
            changePriority: "تغییر اولویت",
            assign: "اختصاص",
            unassign: "لغو اختصاص",
            clearSelection: "پاک کردن انتخاب",
            statusChangeSuccess: "وضعیت {count} تیکت با موفقیت به‌روزرسانی شد",
            statusChangeFailed: "خطا در به‌روزرسانی وضعیت تیکت‌ها",
            priorityChangeSuccess: "اولویت {count} تیکت با موفقیت به‌روزرسانی شد",
            priorityChangeFailed: "خطا در به‌روزرسانی اولویت تیکت‌ها",
            assignSuccess: "{count} تیکت با موفقیت اختصاص داده شد",
            unassignSuccess: "اختصاص {count} تیکت با موفقیت لغو شد",
            assignFailed: "خطا در اختصاص تیکت‌ها",
            // Loading messages
            updatingStatus: "در حال به‌روزرسانی وضعیت تیکت...",
            updatingPriority: "در حال به‌روزرسانی اولویت تیکت...",
            updatingAssignment: "در حال به‌روزرسانی اختصاص تیکت...",
            processing: "در حال پردازش...",
            selectTickets: "عملیات جمعی",
            cancelSelect: "لغو",
        },

        // Activity Timeline
        activity: {
            title: "تاریخچه فعالیت‌ها",
            noActivity: "هنوز فعالیتی ثبت نشده است",
            loadMore: "بارگذاری بیشتر",
            internal: "داخلی",
            by: "توسط",
            systemUser: "سیستم",
            types: {
                created: "ایجاد شد",
                status_changed: "وضعیت تغییر کرد",
                priority_changed: "اولویت تغییر کرد",
                assigned: "اختصاص داده شد",
                unassigned: "لغو اختصاص شد",
                reply_added: "پاسخ اضافه شد",
                internal_note_added: "یادداشت داخلی اضافه شد",
                attachment_added: "فایل پیوست شد",
                sla_breached: "SLA نقض شد",
                escalated: "تشدید شد",
                merged: "ادغام شد",
                split: "تقسیم شد",
                category_changed: "دسته‌بندی تغییر کرد",
                custom_field_updated: "فیلد سفارشی به‌روزرسانی شد",
            },
        },

        // Export
        export: {
            title: "خروجی گرفتن از تیکت‌ها",
            button: "خروجی",
            format: "فرمت",
            csv: "CSV",
            excel: "اکسل",
            exporting: "در حال خروجی گرفتن...",
            success: "تیکت‌ها با موفقیت خروجی گرفته شد",
            failed: "خطا در خروجی گرفتن از تیکت‌ها",
            noTickets: "تیکتی برای خروجی وجود ندارد",
            json: "JSON",
        },

        // Notification Preferences
        notifications: {
            title: "تنظیمات اعلان‌ها",
            settings: "تنظیمات اعلان‌ها",
            loadErrorTitle: "خطا در بارگذاری تنظیمات",
            loadError: "بارگذاری تنظیمات اعلان‌ها با خطا مواجه شد. لطفاً دوباره تلاش کنید.",
            saveSuccess: "تنظیمات اعلان‌ها با موفقیت ذخیره شد",
            saveError: "خطا در ذخیره تنظیمات اعلان‌ها",
            resetSuccess: "تنظیمات اعلان‌ها به حالت پیش‌فرض بازگردانده شد",
            resetError: "خطا در بازنشانی تنظیمات اعلان‌ها",
            enabledAll: "همه اعلان‌ها فعال شد",
            disabledAll: "همه اعلان‌ها غیرفعال شد",
            toggleError: "خطا در تغییر وضعیت اعلان‌ها",
            enableAll: "فعال کردن همه اعلان‌های ایمیل",
            enableAllDesc: "تغییر وضعیت همه تنظیمات اعلان ایمیل به یکباره",
            ticketUpdates: "به‌روزرسانی‌های تیکت",
            slaAlerts: "هشدارهای SLA و تشدید",
            important: "مهم",
            critical: "بحرانی",
            emailNotifications: "اعلان‌های ایمیل",
            newTicket: "تیکت جدید",
            newTicketDesc: "هنگام ایجاد تیکت جدید ایمیل دریافت کنید",
            ticketAssigned: "اختصاص تیکت",
            ticketAssignedDesc: "هنگام اختصاص تیکت به شما ایمیل دریافت کنید",
            ticketReply: "پاسخ تیکت",
            ticketReplyDesc: "هنگام پاسخ دادن به تیکت شما ایمیل دریافت کنید",
            statusChange: "تغییر وضعیت",
            statusChangeDesc: "هنگام تغییر وضعیت تیکت ایمیل دریافت کنید",
            escalation: "تشدید",
            escalationDesc: "هنگام تشدید تیکت ایمیل دریافت کنید",
            slaWarning: "هشدار SLA",
            slaWarningDesc: "هنگام نزدیک شدن موعد SLA تیکت ایمیل دریافت کنید",
            slaBreach: "نقض SLA",
            slaBreachDesc: "هنگام نقض SLA تیکت ایمیل دریافت کنید",
            emailDigest: "خلاصه ایمیل",
            digestFrequencyLabel: "دوره ارسال خلاصه",
            digestFrequencyDesc: "خلاصه فعالیت تیکت‌ها را دریافت کنید",
            selectFrequency: "انتخاب دوره",
            digestFrequency: {
                none: "هیچ",
                daily: "روزانه",
                weekly: "هفتگی",
            },
            inAppNotifications: "اعلان‌های درون‌برنامه‌ای",
            enableInApp: "فعال کردن اعلان‌های درون‌برنامه‌ای",
            enableInAppDesc: "نمایش اعلان‌ها در داخل برنامه",
            resetDefaults: "بازنشانی به پیش‌فرض",
            resetConfirmMessage: "آیا مطمئن هستید که می‌خواهید همه تنظیمات اعلان را به پیش‌فرض بازنشانی کنید؟",
            saveChanges: "ذخیره تغییرات",
        },

        // Time formatting
        time: {
            justNow: "همین الان",
            minutesAgo: "{count} دقیقه پیش",
            hoursAgo: "{count} ساعت پیش",
            daysAgo: "{count} روز پیش",
            weeksAgo: "{count} هفته پیش",
            monthsAgo: "{count} ماه پیش",
        },
    },
    models: {
        name: "اسم",
        provider: "ارائه دهنده",
        tier: "سطح",
        maxTokens: "ظرفیت توکن",
        price: "نرخ",
        costoptimizedModels: "مدل‌های بهینه‌سازی شده از نظر هزینه",
        costoptimizedModelsDes: "مدل‌های کوچکتر و سریع‌تر با هزینه اجرای کمتر",
        flagshipModels: "مدل‌های پرچمدار",
        flagshipModelsDes: "مدل‌های پرچمدار با عملکرد بالا و چندمنظوره",
        imageGeneration: "تولید تصویر",
        imageGenerationDes: "مدل‌هایی که از توضیحات متنی، تصاویر تولید می‌کنند",
        reasoningModels: "مدل‌های استدلالی",
        reasoningModelsDes:
            "مدل‌های پیشرفته‌ای که در وظایف پیچیده و چند مرحله‌ای عملکرد عالی دارند",
        embeddingModels: "مدل‌های امبدینگ",
        embeddingModelsDes: "مدل‌هایی که متن را به بردارهای امبدینگ تبدیل می‌کنند",
        stt: "تبدیل گفتار به متن",
        sttDes: "مدل‌هایی که گفتار را به متن تبدیل می‌کنند",
        tts: "تبدیل متن به گفتار",
        ttsDes: "مدل‌هایی که متن را به گفتار با صدای طبیعی تبدیل می‌کنند",
        visionModels: "مدل‌های بینایی",
        visionModelsDes: "مدل‌هایی که می‌توانند تصاویر را تحلیل و درک کنند",
        chatModels: "مدل‌های گفتگو",
        chatModelsDes: "مدل‌های هوش مصنوعی گفتگوی همه منظوره",
        multimodalModels: "مدل‌های چندوجهی",
        multimodalModelsDes: "مدل‌هایی که از انواع ورودی/خروجی (متن، تصویر، صدا، ویدیو) پشتیبانی می‌کنند",
        moderationModels: "مدل‌های نظارتی",
        moderationModelsDes: "مدل‌هایی که محتوای مضر یا نامناسب را شناسایی و فیلتر می‌کنند",
        codeModels: "مدل‌های برنامه‌نویسی",
        codeModelsDes: "مدل‌های تخصصی در تولید، تحلیل و تکمیل کد",
        noRateLimitReceived: "داده‌ای برای محدودیت نرخ دریافت نشد",
        loadingModels: "در حال بارگذاری مدل‌ها",
        featuredModels: "مدل‌های ویژه",
        modelsFound: "مدل یافت شد",
        searchByModel: "جستجوی مدل‌ها بر اساس نام، ارائه‌دهنده، یا قابلیت...",
        searchByModelDes: "برترین مدل‌های موجود",
        filterModels: "فیلتر مدل‌ها",
        quickFilters: "فیلترهای سریع",
        myAccessibleModels: "مدل‌های قابل دسترس من",
        accessibleModelsDes: "مدل‌هایی که می‌توانم به آنها دسترسی داشته باشم",
        visionModelsTxt: "مدل‌های بینایی",
        visionModelsDes2: "مدل‌ها با قابلیت‌های تصویری",
        reasoningModelsTxt: "مدل‌های استدلالی",
        reasoningModelsDes2: "قابلیت‌های استدلال پیشرفته",
        costEffective: "مقرون به صرفه",
        costEffectiveDes: "گزینه‌های مناسب بودجه",
        providers: "ارائه‌دهندگان",
        selectProviders: "انتخاب ارائه‌دهندگان",
        capabilities: "قابلیت‌ها",
        showMore: "نمایش بیشتر",
        showLess: "نمایش کمتر",
        more: "بیشتر",
        selectCapabilities: "انتخاب قابلیت‌ها",
        accessTiers: "سطوح دسترسی",
        selectTiers: "انتخاب سطوح",
        priceRange: "محدوده قیمت (به ازای ۱ میلیون توکن)",
        sortBy: "مرتب‌سازی بر اساس",
        onlyAccessible: "فقط نمایش مدل‌های قابل دسترس من",
        of: "از",
        models: "مدل",
        filter: "فیلتر",
        filters: "فیلترها",
        active: "فعال",
        applyFiltersClose: "اعمال فیلترها و بستن",
        providersPlaceholder: "ارائه‌دهندگان",
        capabilitiesPlaceholder: "قابلیت‌ها",
        tiersPlaceholder: "سطوح",
        categoryPlaceholder: "دسته‌بندی",
        allCategories: "همه دسته‌بندی‌ها",
        tierLabel: "سطح {0}",
        clearFilters: "پاک کردن فیلترها",
        categoryModelsCount: "مدل",
        noModelsFound: "هیچ مدلی یافت نشد",
        filtersActive: "فیلتر فعال",
    },
    tooltip: {
        tpm: "مقدار دسترسی توکن در دقیقه (TPM) بر اساس سطح کاربری انتخاب شده، این مقدار در هر سطح کاربری متفاوت است.",
        rpm: "درخواست در دقیقه (RPM) بر اساس سطح کاربری انتخاب شده، این مقدار در هر سطح کاربری متفاوت است.",
        negativeBalance: "موجودی منفی",
        negativeBalanceExplanation:
            "موجودی کیف پول شما منفی است، دلیل آن درخواست‌های موازی در تعداد بالا است زمانی که اعتبار باقی مانده نزدیک به صفر بوده.",
        negativeTotalBalance: "جزئیات موجودی منفی",
        currentBalance: "موجودی فعلی",
        pendingCharges: "هزینه‌های بلاتکلیف",
        rechargeAdvice: "جهت استفاده از خدمات لطفا موجودی حساب را شارژ نمایید.",
        remainingIRT: "باقی مانده اعتبار تومانی کیف پول",
        remainingUNIT: "باقی مانده اعتبار کیف پول تبدیل شده به واحد (نرخ تتر)",
        imagePricingAlert:
            "محاسبه هزینه در مدل‌های تولید تصویر بر اساس نوع مدل، اندازه تصویر، کیفیت، و تعداد گام‌ها (در صورت پشتیبانی مدل از این قابلیت) انجام می‌شود. بنابراین، نرخ اعلام‌شده برای هر تصویر، یک نرخ متوسط تلقی می‌گردد. به جز مدل gpt-image-1، سایر مدل‌ها نرخ خروجی توکن ندارند و این مقدار صرفا جهت سازگاری با سیستم تخصیص داده می‌شود. به عنوان مثال، در فراخوانی مدل dall-e-3 با کیفیت HD و اندازه ۱۰۲۴ در ۱۰۲۴، مقدار توکن مصرفی ۱۰۰۰ در نظر گرفته می‌شود که با نرخ ۴۰ واحد به ازای هر یک میلیون توکن، معادل ۰.۰۴ واحد محاسبه خواهد شد. این مقدار در واقع نرخ پایه خروجی تصویر و معادل ۰.۰۴ واحد به ازای هر تصویر است.",
        remainingInUNIT:
            "مجموع ارزش اعتبار تومانی به واحد به علاوه اعتبار تبدیل شده به واحد. این مقدار ارزش کل اعتبار حساب به واحد با نرخ تبدیل لحظه‌ای است.",
        aboveTokensPricing:
            "هنگامی که مجموع توکن‌ها بالاتر از مقدار مشخص شده باشد، مبنای نرخ بر این اساس محاسبه می شود، در مواردی که مجموع توکن‌ها کمتر از این مقدار است، نرخ پایه مبنای محاسبه است، جهت کسب اطلاعات بیشتر به مستندات ارائه دهنده مراجعه نمایید.",
        endpointMightNotAvailable:
            "برخی از نقاط پایانی ممکن است در حال حاضر در AvalAI در دسترس نباشند. لطفا برای اطلاعات بیشتر به مستندات مراجعه کنید.",
        remainingCreditInIrtEquivalent:
            "مجموع اعتبار کیف پول شما به تومان. این موجودی شامل باقی مانده تومانی به علاوه باقی مانده «واحد» ضرب در نرخ لحظه‌‌ای است. به دلیل اینکه نرخ گذاری بسته‌های اعتباری بر اساس تومان است، درصورتی که موجودی کیف پول شما، دارای موجودی ارزی بر حسب «واحد» باشد، معادل آن به تومان بر اساس نرخ لحظه‌ای محاسبه می گردد.",
    },
    limits: {
        selectModalities: "وجه ادراک",
        selectEndpoints: "نقاط پایانی",
        rateLimits: "سطوح دسترسی",
        supported_endpoints: "نقاط پایانی پشتیبانی شده",
        supports_parallel_function_calling: "Parallel Function Calling",
        supports_web_search: "پشتیبانی از جستجوی وب",
        max_images_per_prompt: "حداکثر تعداد تصویر ورودی",
        max_videos_per_prompt: "حداکثر تعداد ویدیو ورودی",
        max_video_length: "حداکثر طول ویدیو",
        max_audio_length_hours: "حداکثر زمان آوا (ساعت)",
        max_audio_per_prompt: "حداکثر آوا در هر پرامپت",
        max_pdf_size_mb: "حداکثر حجم PDF (مگابایت)",
        supported_modalities: "وجه ادارک‌های پشتیبانی شده (Modalities)",
        supported_output_modalities:
            "وجه ادارک‌های خروجی پشتیبانی شده (Modalities)",
        costPerOneMillionTokens: "بر اساس هر ۱ میلیون توکن بر مبنای نرخ واحد (تتر)",
        details: "جزئیات",
        name: "مدل",
        max_tokens: "حداکثر توان خروجی",
        max_input_tokens: "حداکثر ورودی",
        max_requests_per_1_minute: "RPM",
        max_tokens_per_1_minute: "TPM",
        // Nested pricing fields
        pricing: {
            input_cost_per_token: "هزینه ورودی هر یک توکن",
            output_cost_per_token: "هزینه خروجی هر یک توکن",
            input_cost_per_page: "هزینه هر یک صفحه یا تصویر",
            input_cost_per_query: "هزینه هر یک مرتبه فراخوانی",
            kTokens: "هزار توکن",
            input: "نرخ توکن ورودی",
            input_above: "نرخ توکن ورود بالاتر از",
            input_above_128k: "نرخ توکن ورود بالاتر از 128k توکن",
            input_above_200k: "نرخ توکن ورود بالاتر از 200k توکن",
            output: "نرخ توکن خروجی",
            output_above: "نرخ توکن خروجی بالاتر از",
            output_above_128k: "نرخ توکن خروجی بالاتر از 128k توکن",
            output_above_200k: "نرخ توکن خروجی بالاتر از 200k توکن",
            cached_input: "نرخ ورودی کش شده",
            cache_creation_input: "نرخ تولید ورودی کش شده",
            audio_input: "نرخ ورودی صوتی",
            audio_output: "نرخ خروجی صوتی",
            input_cost_per_character: "نرخ ورودی کاراکتر",
            input_cost_per_second: "نرخ ورودی ثانیه",
            output_cost_per_second: "نرخ خروجی ثانیه",
            audio_cached_input: "نرخ ورودی صوتی کش شده",
            output_cost_per_image: "نرخ تولید تصویر",
            output_cost_per_video_per_second: "هر ثانیه ویدیو ابعاد پیش فرض",
            output_cost_per_video_per_second_720x1280: "هر ثانیه ویدیو ابعاد 720x1280",
            output_cost_per_video_per_second_1280x720: "هر ثانیه ویدیو ابعاد 1280x720",
            output_cost_per_video_per_second_1024x1792: "هر ثانیه ویدیو ابعاد 1024x1792",
            output_cost_per_video_per_second_1792x1024: "هر ثانیه ویدیو ابعاد 1792x1024",
            source: "منبع",
        },
        outputVideo: "خروجی ویدیو",
        outputImage: "خروجی تصویر",
        perOneImage: "به ازای هر تصویر",
        outputSeconds: "ثانیه خروجی",
        perOneSecond: "هر ثانیه",
        inputSeconds: "ثانیه ورودی",
        perOneCharacterInput: "هر عدد کاراکتر",
        characterInput: "کاراکتر ورودی",
        modelCapabilities: "قابلیت‌ها",
        maxTokens: "حداکثر ظرفیت",
        maxInputTokens: "حداکثر ورودی",
        maxOutputTokens: "حداکثر توان خروجی",
        mode: "حالت",
        source: "منبع",
        supportsSystemMessages: "پیغام سیستم",
        supportsFunctionCalling: "Function Calling",
        supportsVision: "Vision",
        supportsToolChoice: "Tool Choice",
        supportsResponseSchema: "Response Schema",
        supportsPromptCaching: "Prompt Caching",
        supportsReasoning: "استدلال",
        howToUseApi1:
            "دریافت لیست مدل‌ها از طریق API",
        audioPerMinute: "صوت در دقیقه",
        imagesPerMinute: "تصویر در دقیقه",
        searchModel: "جستجوی مدل",
        selectOwner: "فیلتر صاحب‌ امتیاز",
        owner: "صاحب امتیاز",
        tier0: "پایه",
        tier1: "سطح ۱",
        tier2: "سطح ۲",
        tier3: "سطح ۳",
        tier4: "سطح ۴",
        tier5: "سطح ۵",
        audioInputTokens: "توکن صوتی ورودی",
        audioOutputTokens: "توکن صوتی خروجی",
        audioCachedInputTokens: "توکن صوتی ورودی کش شده",
        minute: "دقیقه",
        perMinute: "در دقیقه",
        perOneMillionTokens: "هر ۱ میلیون توکن",
        currency: "ارز",
        costCalculator: "محاسبه هزینه‌ها",
        inputTokens: "توکن ورودی",
        cachedInputTokens: "توکن ورودی کش شده",
        outputTokens: "توکن خروجی",
        audioInputMinutes: "دقایق ورودی",
        audioCachedInputMinutes: "دقایق ورودی کش شده",
        audioOutputMinutes: "دقایق خروجی",
        estimatedCost: "هزینه تخمینی",
        tokenBasedPricing: "نرخ بر اساس توکن",
        audioBasedPricing: "نرخ بر اساس واحد صوت / دقیقه",
        modelDetails: "جزئیات مدل",
        actions: "",
        providerType: "نوع ارائه دهنده",
        viewPricing: "مشاهده نرخ‌ها",
        pricingDetails: "جزئیات نرخ‌ها",
        // Service Tier Pricing
        serviceTier: "سطح سرویس",
        serviceTiers: "سطوح سرویس",
        selectServiceTiers: "سطوح سرویس",
        serviceTierFilter: "فیلتر سطح سرویس",
        serviceTierPricing: "نرخ بر اساس سطح سرویس",
        standardTier: "استاندارد",
        defaultTier: "استاندارد",
        flexTier: "منطعف",
        batchTier: "عمده",
        priorityTier: "اولویت‌دار",
        defaultTierDescription: "سطح نرخ پیش‌ فرض",
        standardTierDescription: "سطح نرخ پیش‌ فرض",
        flexTierDescription: "هزینه کمتر، تاخیر متغیر",
        batchTierDescription: "پردازش غیرهمزمان",
        priorityTierDescription: "دسترسی سریع و اولویت‌دار",
        flexAvailable: "منعطف در دسترس",
        supportsFlexPricing: "پشتیبانی از نرخ منعطف",
        learnMoreAboutServiceTiers: "اطلاعات بیشتر درباره سطوح سرویس",
        // Service Tier Explanation Modal
        serviceTierExplanation: {
            title: "آشنایی با سطوح سرویس",
            overview: "سطوح سرویس به شما امکان می‌دهند استفاده از API را بر اساس نیازهای خاص خود بهینه‌سازی کنید. سطوح مختلف توازن‌های متفاوتی بین هزینه، تاخیر و دسترسی ارائه می‌دهند.",
            standardTitle: "سطح استاندارد",
            standardDescription: "سطح سرویس پیش‌فرض که عملکرد پایدار و قابل پیش‌بینی با قیمت‌گذاری استاندارد ارائه می‌دهد.",
            standardFeature1: "زمان پاسخ‌دهی قابل پیش‌بینی",
            standardFeature2: "محدودیت‌های نرخ استاندارد اعمال می‌شود",
            standardFeature3: "بهترین گزینه برای بارهای کاری تولید که به تاخیر ثابت نیاز دارند",
            flexTitle: "سطح منعطف",
            flexDescription: "سطح بهینه‌شده از نظر هزینه که صرفه‌جویی قابل توجهی در ازای تاخیر متغیر ارائه می‌دهد. مناسب برای بارهای کاری غیر حساس به زمان.",
            flexFeature1: "تا ۵۰٪ کاهش هزینه نسبت به سطح استاندارد",
            flexFeature2: "تاخیر متغیر - پاسخ‌ها ممکن است در زمان‌های اوج بیشتر طول بکشند",
            flexFeature3: "ایده‌آل برای پردازش دسته‌ای، وظایف پس‌زمینه یا برنامه‌های حساس به هزینه",
            flexNote: "درخواست‌های سطح منعطف با اولویت پایین و زمانی که ظرفیت در دسترس است پردازش می‌شوند. زمان پاسخ‌دهی ممکن است بسته به تقاضا از چند ثانیه تا چند دقیقه متغیر باشد.",
            howToUseTitle: "نحوه استفاده از سطوح سرویس",
            howToUseDescription: "برای استفاده از یک سطح سرویس خاص، پارامتر 'service_tier' را در درخواست API خود قرار دهید:",
            supportedModelsTitle: "مدل‌های پشتیبانی‌شده",
            supportedModelsDescription: "در حال حاضر، فقط برخی از مدل‌های OpenAI از نرخ‌گذاری منعطف پشتیبانی می‌کنند. لیست مدل‌های پشتیبانی‌شده ممکن است در آینده افزایش یابد.",
            modelAliases: "نام‌های جایگزین مدل",
            pricingTitle: "مزایای قیمت‌گذاری",
            pricingDescription: "قیمت‌گذاری سطح منعطف معمولا ۵۰٪ کمتر از قیمت‌گذاری سطح استاندارد است. تخفیف دقیق بسته به مدل متفاوت است.",
            pricingExample: "مثال: اگر قیمت ورودی استاندارد ۲ دلار/۱ میلیون توکن باشد، قیمت منعطف حدود ۱ دلار/۱ میلیون توکن خواهد بود.",
            latencyTitle: "ملاحظات تاخیر",
            latencyDescription: "سطح استاندارد پاسخ‌های ثابت با تاخیر کم ارائه می‌دهد که برای برنامه‌های بلادرنگ ایده‌آل است. سطح منعطف ممکن است تاخیر متغیری از چند ثانیه تا چند دقیقه داشته باشد، که آن را برای بارهای کاری ناهمزمان که پاسخ فوری حیاتی نیست مناسب می‌سازد.",
            creditPackageWarningTitle: "مهم: بسته‌های اعتباری",
            creditPackageWarning: "استفاده از سطح منعطف توسط بسته‌های اعتباری پوشش داده نمی‌شود! اگر از بسته‌های اعتباری استفاده می‌کنید، فراخوانی‌های API با service_tier == flex از موجودی استاندارد شما کسر می‌شود نه از اعتبار بسته شما.",
        },
        inputPrice: "نرخ ورودی",
        cachedInputPrice: "نرخ ورودی کش شده",
        cacheCreationInputPrice: "نرخ تولید ورودی کش شده",
        outputPrice: "نرخ خروجی",
        audioInputPrice: "نرخ صدای ورودی",
        audioOutputPrice: "نرخ صدای تولید شده",
        noPricingAvailable: "نرخ گذاری در دسترس نیست",
        shortDesc1: "مشاهده و بررسی سطح دسترسی به مدل‌های مختلف",
        title: "محدودیت‌های دسترسی",
        provider: "ارائه دهنده",
        providerTooltip: "برخی مدل‌ها ممکن است ارائه‌دهندگان متفاوتی نسبت به مالک خود داشته باشند (مثلا deepseek.r1-v1:0 متعلق به DeepSeek است اما توسط AWS Bedrock ارائه می‌شود). همچنین مدل‌های یکسان در ارائه‌دهندگان مختلف ممکن است قیمت‌گذاری متفاوتی داشته باشند.",
        model: "مدل",
        tpm: "توکن در دقیقه (TPM)",
        rpm: "درخواست در دقیقه (RPM)",
        info1:
            "سطوح دسترسی API منطبق با OpenAI تنظیم شده. دو نوع محدودیت اصلی شامل «توکن در دقیقه» به اختصار (TPM) و «درخواست در دقیقه یا روز» به اختصار (RPM/RPD) می‌شوند.",
        readDoc1: "با مطالعه مستندات",
        readDoc2: "راهنمای سطح دسترسی",
        readDoc3:
            "میتوانید در مورد چگونگی آن اطلاعات بیشتری کسب نمایید.",
        usageTier: "سطح دسترسی",
        noAccess: "بدون دسترسی",
        free: "پایه",
        tier: "سطح",
        completed: "تکمیل شده",
        current: "فعلی",
        upcoming: "بعدی",
        toIncreaseTier: "برای ارتقا به سطح دسترسی بعد:",
        increaseYourLimits: "ارتقای سطح دسترسی",
        youCurrentTier: "حساب شما در",
        ast: "قرار دارد",
        youWillmoveIf:
            "محدودیت‌های شما به صورت خودکار به سطح استفاده بعدی بر اساس معیارهای زیر افزایش خواهند یافت. برای کسب اطلاعات بیشتر به",
        toLearMore: "درباره محدودیت‌های مرتبط با هر سطح استفاده مراجعه کنید.",
        tiers: {
            zero: { p1: "برای فعال شدن دسترسی پایه API، ایمیل خود را تایید کنید.", p2: "", p3: "", p4: "" },
            tier0: { p1: "سطح پایه برای کاربران با ایمیل تایید شده.", p2: "با تایید شماره تلفن به سطح دسترسی ۱ ارتقا پیدا می‌کنید.", p3: "", p4: "" },
            tier1: {
                p1: "شماره تلفن خود را تایید کنید. هیچ حداقل پرداختی لازم نیست.",
                monthlyLimit: "سقف مصرف تا ۱۰۰ واحد در ماه.",
                p2: "",
                p3: "",
                p4: "",
            },
            tier2: {
                p1: "دستکم ۱۰ واحد (یا معادل آن) از زمان ایجاد حساب کاربری شارژ شده باشد.",
                p2: "",
                monthlyLimit: "سقف مصرف تا ۵۰۰ واحد در ماه.",
                p3: "",
                p4: "",
            },
            tier3: {
                p1: "دستکم ۵۰ واحد (یا معادل آن) از زمان ایجاد حساب کاربری شارژ شده باشد.",
                p2: "",
                monthlyLimit: "سقف مصرف تا ۱,۰۰۰ واحد در ماه.",
                p3: "",
                p4: "",
            },
            tier4: {
                p1: "دستکم ۲۵۰ واحد (یا معادل آن) از زمان ایجاد حساب کاربری شارژ شده باشد.",
                p2: "",
                monthlyLimit: "سقف مصرف تا ۵,۰۰۰ واحد در ماه.",
                p3: "",
                p4: "",
            },
            tier5: {
                p1: "دستکم ۱,۰۰۰ واحد (یا معادل آن) از زمان ایجاد حساب کاربری شارژ شده باشد.",
                p2: "",
                monthlyLimit: "سقف مصرف تا ۱۰,۰۰۰ واحد در ماه.",
                p3: "",
                p4: "",
            },
        },
        // Tier Upgrade System Localizations
        upgradeTitle: "ارتقای سطح دسترسی",
        maxTierTitle: "حداکثر سطح دسترسی",
        upgradeDescription:
            "با ارتقا به سطح بالاتر، قابلیت‌های دسترسی API خود را افزایش دهید. سطوح بالاتر امکان دسترسی به مدل‌های بیشتر، محدودیت‌های نرخ بالاتر (TPM/RPM) و ویژگی‌های مرتبط با سطح بعدی را فراهم می‌کنند.",
        maxTierDescription:
            "تبریک! شما به بالاترین سطح دسترسی رسیده‌اید و از حداکثر مزایا و دسترسی نامحدود به تمام ویژگی‌ها بهره‌مند هستید.",
        tierProgress: "پیشرفت سطح دسترسی",
        howItWorks: "نحوه عملکرد ارتقای سطح",
        importantNotes: "اطلاعات مهم",
        currentTier: "سطح فعلی",
        nextTier: "سطح بعدی",
        progress: "پیشرفت",
        totalPaid: "مجموع پرداختی",
        required: "مورد نیاز",
        remaining: "باقی‌مانده",
        currentBenefits: "مزایای فعلی",
        nextTierBenefits: "مزایای سطح بعدی",
        upgradeNow: "ارتقا دهید",
        maxTierReached: "حداکثر سطح دسترسی!",
        upgradeToNextTier: "ارتقاء به سطح بعدی",
        unlockBenefits: "دسترسی فوری به تمام امکانات ویژه",
        instantUpgrade: "ارتقاء فوری • بدون انتظار • بدون هزینه",

        // Step-by-step process
        step1Title: "تایید تلفن یا شارژ حساب",
        step1Description:
            "تایید شماره تلفن، حساب دارای ایمیل تایید شده را بدون نیاز به حداقل پرداخت به سطح دسترسی ۱ ارتقا می‌دهد. برای رسیدن به سطح ۲ و بالاتر، حساب خود را شارژ کنید.",
        step2Title: "محاسبه خودکار سطح",
        step2Description:
            "سیستم معادل واحد (UNIT) پرداخت تومان شما را در زمان پرداخت محاسبه می‌کند تا مجموع پرداختی را جهت ارتقای سطح محاسبه کند. ارتقای سطح ۲ و بالاتر بر اساس این مجموع ارزش مادام‌العمر به واحد انجام می‌شود.",
        step3Title: "از محدودیت‌های بهبود یافته لذت ببرید",
        step3Description:
            "بلافاصله پس از ارتقای سطح، به محدودیت‌های نرخ بالاتر، مدل‌های بیشتر و ویژگی‌های ویژه دسترسی پیدا کنید.",
        step4Title: "اعتبارات خود را حفظ کنید",
        step4Description:
            "تمام اعتبارات شارژ شده شما برای استفاده از API در دسترس باقی می‌مانند. ارتقای سطح اعتبارات شما را مصرف نمی‌کند.",
        step5Title: "مزایای دائمی",
        step5Description:
            "پس از ارتقا، مزایای سطح شما دائمی است و هرگز کاهش نخواهد یافت.",

        // Amount selection features
        selectAmount: "انتخاب مبلغ شارژ",
        suggestedAmount: "پیشنهادی",
        suggestedAmountTooltip:
            "مبلغ توصیه شده با ۱٪ بافر برای محافظت در برابر نوسانات نرخ ارز",
        selectedAmount: "مبلغ انتخابی",
        minimumRequired: "حداقل مورد نیاز",
        exchangeRate: "نرخ تبدیل",
        useSuggested: "استفاده از پیشنهادی",

        // Tier selection features
        selectTargetTier: "انتخاب سطح هدف",
        selectTierPlaceholder: "سطح مورد نظر برای ارتقا را انتخاب کنید",
        selectedTier: "سطح انتخابی",
        tier1PhoneVerificationUpgrade:
            "برای ارتقا به سطح دسترسی ۱، شماره تلفن خود را تایید کنید. هیچ پرداخت یا حداقل مجموع پرداختی لازم نیست.",
        emailVerificationRequired: "ایمیل تایید شده",
        emailVerified: "ایمیل تایید شود",
        phoneVerified: "شماره تلفن تایید شود",
        targetTierBenefits: "مزایای سطح هدف",
        upgradeToSelectedTier: "ارتقا به سطح انتخابی",
        resetToNext: "بازگشت به بعدی",
        recommended: "توصیه شده",
        cost: "هزینه",

        // Important notes
        note1:
            "سطح دسترسی ۱ نیازمند تایید تلفن است؛ سطح ۲ و بالاتر بر اساس مجموع پرداخت‌های انجام شده محاسبه می‌شود",
        note2: "تمام اعتبارات شارژ شده برای استفاده از API در دسترس باقی می‌مانند",
        note3:
            "سطوح بالاتر امکان دسترسی به مدل‌های پیشرفته‌تر هوش مصنوعی و ویژگی‌ها را فراهم می‌کنند",

        // Tier Benefits
        benefits: {
            tier0: {
                basic: "دسترسی پایه API با محدودیت‌های ابتدایی",
                limited: "دسترسی فقط به مدل‌های ضروری",
            },
            tier1: {
                increased: "محدودیت‌های نرخ و ظرفیت توکن افزایش یافته",
                priority: "پشتیبانی اولویت‌دار و زمان پاسخ سریع‌تر",
                models: "دسترسی به مدل‌های هوش مصنوعی اضافی",
            },
            tier2: {
                higher: "محدودیت‌های استفاده ماهانه بالاتر (۵۰۰ واحد/ماه)",
                advanced: "دسترسی به مدل‌های استدلالی پیشرفته",
                support: "پشتیبانی بهبود یافته کاربران",
            },
            tier3: {
                premium: "دسترسی ویژه با محدودیت ۱۰۰۰ واحد/ماه",
                enhanced: "انتخاب مدل و قابلیت‌های بهبود یافته",
                features: "دسترسی به ویژگی‌های آزمایشی و انتشارات جدید",
            },
            tier4: {
                enterprise: "دسترسی سطح سازمانی (۵۰۰۰ واحد/ماه)",
                maximum: "حداکثر محدودیت‌های نرخ و پردازش اولویت‌دار",
                dedicated: "پشتیبانی اختصاصی و پیکربندی‌های سفارشی",
            },
            tier5: {
                unlimited: "دسترسی نامحدود به تمام ویژگی‌ها و مدل‌ها",
                all: "دسترسی به تمام مدل‌های هوش مصنوعی فعلی و آینده",
                priority: "بالاترین اولویت پشتیبانی و راه‌حل‌های سفارشی",
            },
        },
        // Authentication and verification messages
        notLoggedIn: "وارد نشده‌اید",
        loginRequired:
            "لطفا برای دسترسی به مزایای سطح و گزینه‌های ارتقا وارد شوید.",
        loginNow: "ورود",
        phoneNotVerified: "تلفن تایید نشده است",
        phoneVerificationRequired:
            "لطفا برای باز کردن قفل مزایای سطح، شماره تلفن خود را تایید کنید.",
        verifyPhone: "تایید تلفن",
        notAuthenticated: "احراز هویت مورد نیاز است",
        authenticationRequired:
            "لطفا برای دسترسی به مزایای سطح خود، احراز هویت را کامل کنید.",
        authenticateNow: "احراز هویت",
        accessRestricted: "دسترسی محدود شده است",
        verificationRequired:
            "لطفا برای دسترسی به مزایای سطح، تایید را کامل کنید.",
        getVerified: "تایید شوید",
    },
    usage: {
        totalUsed: "استفاده شده",
        totalAudio: "مجموع آوا",
        audioInputSeconds: "آوای ورودی",
        audioOutputSeconds: "آوای خروجی",
        all: "همه",
        success: "موفق",
        pending: "بلاتکلیف",
        failed: "ناموفق",
        summary: "خلاصه",
        download: "بارگذاری",
        action: "عملیات",
        status: "وضعیت",
        expiresAt: "تاریخ انقضا",
        generatedAt: "تاریخ صدور",
        consumptionReport: "گزارش مصارف",
        generateReport: "صدور گزارش",
        timeFrame: "بازه زمانی",
        meanExchangeRate: "متوسط نرخ تبدیل",
        inputTokens: "توکن وروردی",
        outputTokens: "توکن خروجی",
        cachedTokens: "توکن کش شده",
        request: "درخواست",
        totalTokens: "مجموع توکن‌ها",
        totalRequests: "مجموع درخواست‌ها",
        costs: "هزینه‌ها",
        cost: "هزینه‌",
        tokens: "توکن",
        requests: "درخواست‌ها",
        title: "مصارف",
        daily: "روزانه",
        hourly: "ساعتی",
    },
    feedback: {
        sendFeedback: "ثبت بازخورد",
        description: "نظر خود را با ما در میان بگذارید",
        title: "عنوان",
        titleInputPlaceHolder: "چه موضوعی مد نظر شماست؟",
        body: "بازخورد",
        bodyInputPlaceHolder:
            "بازخورد شما، هر آنچه که میخواهید با ما در میان بگذارید.",
        footerDescription:
            "ارائه بازخورد می‌تواند به ما کمک کند تا سیستم خود را بهبود بخشیم و تجربه کاربری را برای همه بهتر کنیم.",
        sendButton: "ارسال",
        thankYouTitle: "متشکریم!",
        thankYouMessage:
            "ما بازخورد شما را دریافت کردیم. معمولا دو روز طول می‌کشد تا پاسخی از ما دریافت کنید، اما گاهی اوقات زودتر.",

        okayButton: "باشه",
        sendFailed: "ارسال بازخورد با خطا مواجه شد",
        sendSuccess: "بازخورد ثبت شد",
        bodyCantBeEmpty: "متن بازخورد نمیتواند خالی باشد",
        bodyTooShort: "متن بازخورد نباید کمتر از ۲۰ کاراکتر باشد",
    },
    languages: {
        "fa-IR": "فارسی",
        "en-US": "انگلیسی",
        // Add other languages as needed
    },
    paymentStatus: {
        success: "موفق",
        pending: "در انتظار",
        failed: "ناموفق",
        processing: "در حال پردازش",
    },
    status: {
        pending: "در انتظار",
        completed: "تکمیل شده",
        failed: "ناموفق",
    },
    reports: {
        longerFramesRateLimit: "برای گزارش‌های با بازه زمانی بیش از ۳ روز، تنها یک درخواست در هر ۲۴ ساعت مجاز است.",
        reportGenerationSubmitted: "درخواست گزارش ثبت شد، لطفا وضعیت گزارش را در لیست زیر بررسی نمایید. صدور برخی گزارش‌ها ممکن است تا ۶۰ دقیقه زمان بر باشد.",
        title: "گزارش مصارف API",
        timeFrame: "بازه زمانی",
        generateReport: "صدور گزارش",
        reportSummary: "خلاصه گزارش",
        downloadReport: "بارگذاری",
        viewSummary: "خلاصه",
        lastHour: "یک ساعت پیش",
        last6Hours: "۶ ساعت گذشته",
        last12Hours: "۱۲ ساعت گذشته",
        lastDay: "۲۴ ساعت گذشته",
        last2Days: "۴۸ ساعت گذشته",
        last3Days: "۷۲ ساعت گذشته",
        lastWeek: "هفته گذشته",
        last28Days: "۲۸ روز گذشته",
        lastMonth: "ماه گذشته",
        last3Months: "۳ ماه گذشته",
        last6Months: "۶ ماه گذشته",
        lastYear: "سال گذشته",
        allTime: "از ابتدا",
        columns: {
            language: "زبان",
            generatedAt: "تاریخ صدور",
            timeFrame: "بازه زمانی",
            expiresAt: "تاریخ انقضا",
            status: "وضعیت",
        },
        summary: {
            user: "کاربر",
            dateRange: "بازه زمانی",
            generatedAt: "تاریخ صدور",
            totalTransactions: "تعداد کل تراکنش‌‌ها",
            totalCostUnits: "کل هزینه به واحد",
            totalPaidUnits: "کل هزینه پرداختی به واحد",
            totalPaidIRT: "کل هزینه پرداختی تومانی",
            totalPaidGrantIRT: "کل هزینه پرداخت شده از اعتبارات هدیه",
            financialDetails: "خلاصه هزینه‌ها",
        },
    },
    billing: {
        noCreditPackages: "بسته اعتباری فعال نیست",
        manageCreditPackages: "مدیریت بسته‌های اعتباری",
        packagesTotalUnit: "مجموع بسته‌های اعتباری معادل واحد",
        expirationTimeline: "تاریخ انقضای بسته‌های اعتباری",
        creditBreakdown: "بسته‌های اعتباری",
        unnamedPackage: "بسته اعتباری",
        sortOptions: {
            featured: "ویژه",
            price: "قیمت (کم به زیاد)",
            valueRatio: "نسبت ارزش",
            newest: "جدیدترین",
            oldest: "قدیمی‌ترین",
            expiration: "زمان انقضا",
        },
        packages: {
            myPackages: "بسته‌های من",
            promotional: "فروش ویژه",
            summary: {
                total: "کل بسته‌ها",
                active: "بسته‌های فعال",
                usage: "میانگین استفاده",
                remaining: "باقی‌مانده بسته‌ها",
                totalSources: "کل منابع",
                packages: "بسته‌های اعتباری",
                grants: "گرنت‌ها",
                totalBalance: "کل موجودی",
            },
            tabs: {
                overview: "نمای کلی",
                usage: "تحلیل استفاده",
                expiration: "جدول زمانی انقضا",
            },
            otp: {
                title: "تایید خرید به مبلغ {amount}",
                description:
                    "لطفا کد تایید ۶ رقمی ارسال شده به تلفن همراه خود را برای تکمیل خرید وارد کنید.",
                invalidLength: "طول کد تایید نامعتبر است",
                send: "ارسال کد",
                resent: "کد تایید مجددا ارسال شد",
                expiresIn: "کد در {time} منقضی می‌شود",
                expired: "کد تایید منقضی شده است",
                cancel: "لغو",
                verify: "تایید کد",
                resend: "ارسال کد جدید",
            },
            timeline: {
                expired: "منقضی شده",
                thisMonth: "این ماه",
                nextMonth: "ماه آینده",
                noExpiration: "هیچ بسته‌ای تاریخ انقضا ندارد",
                expiredCount: "بسته‌های منقضی شده",
                expiringThisWeek: "این هفته منقضی می‌شوند",
                expiringThisMonth: "این ماه منقضی می‌شوند",
                safePeriod: "دوره امن (بیش از ۳۰ روز)",
                summary: "خلاصه",
                later: "بعدا",
                remaining: "باقی مانده",
            },
            filters: {
                title: "فیلترها",
                reset: "بازنشانی فیلترها",
                allServices: "تمام سرویس‌ها",
                serviceType: "نوع سرویس",
                apiOnly: "فقط API",
                subscriptionOnly: "فقط اشتراک",
                showPromotional: "نمایش بسته‌های تبلیغاتی",
                priceRange: "محدوده قیمت",
                subServices: "زیر سرویس‌ها",
                modelFamilies: "خانواده مدل‌ها",
                subscriptionTiers: "سطوح اشتراک",
            },
            authRequired: {
                title: "ورود به حساب کاربری، ضروری است.",
                description:
                    "لطفا وارد حساب کاربری خود شوید تا بسته‌های خریداری شده و میزان استفاده از آن‌ها را مشاهده کنید.",
            },
            paymentMethods: {
                bankCard: "کارت بانکی",
                creditBalance: "موجودی اعتباری",
            },
            status: {
                all: "همه",
                active: "فعال",
                expired: "منقضی شده",
                exhausted: "تمام شده",
            },
            totalAmountBePaid: "مبلغ کل پرداختی",
            totalCreditsReceiving: "کل اعتبارات دریافتی",
            empty: "هیچ بسته‌ای موجود نیست",
            emptyDescription: "در حال حاضر هیچ بسته اعتباری برای خرید موجود نیست",
            allServices: "تمام سرویس‌ها",
            noExpiration: "بدون انقضا",
            creditPackages: "بسته‌های اعتباری",
            grantCredits: "اعتبارات هدیه",
            generalBalance: "موجودی کیف پول",
            generalBalanceDescription: "موجودی اصلی کیف پول شما برای تمام سرویس‌ها",
            creditsPerToman: "اعتبار بیشتر",
            expired: "منقضی شده",
            expirestoday: "امروز منقضی می‌شود",
            expiresTomorrow: "فردا منقضی می‌شود",
            expiresInDays: "{days} روز دیگر",
            expiresInWeeks: "{weeks} هفته دیگر منقضی می‌شود",
            expiresOn: "در تاریخ {date} منقضی می‌شود",
            redirectingToPayment: "در حال انتقال به درگاه پرداخت",
            purchaseComplete: "خرید با موفقیت تکمیل شد",
            purchaseSuccessMessage:
                "بسته اعتباری شما خریداری و به حساب شما اضافه شده است. اکنون می‌توانید آن را در بخش بسته‌های من مشاهده و مدیریت کنید.",
            goToMyPackages: "رفتن به بسته‌های من",
            purchaseFailed: "خرید ناموفق بود. لطفا دوباره تلاش کنید.",
            insufficientCredit: "موجودی اعتبار ناکافی",
            insufficientCreditMessage:
                "موجودی اعتبار شما برای تکمیل این خرید کافی نیست. شما به {shortfall} تومان دیگر نیاز دارید.",
            choosePaymentOption: "یک گزینه پرداخت انتخاب کنید:",
            useDirectPayment: "پرداخت مستقیم بانکی",
            topUpCredit: "افزایش اعتبار کیف پول",
            otpFailed: "تایید کد ناموفق بود",
            paymentCheckFailed:
                "بررسی وضعیت پرداخت ناموفق بود. لطفا دوباره تلاش کنید.",
            openPaymentPage: "بازگشت به صفحه پرداخت",
            paymentPending:
                "تراکنش هنوز تکمیل نشده است، لطفا پرداخت را تکمیل یا مجدد وضعیت تراکنش را بررسی نمایید.",
            paymentNotFound: "تراکنش یافت نشد! لطفا دوباره تلاش کنید.",
            clearFilters: "پاک کردن فیلترها",
            browse: "مرور بسته‌ها",
            title: "بسته‌های اعتباری",
            description:
                "با خرید بسته‌های اعتباری، در هزینه‌ها صرفه جویی و موجودی حساب خود را مدیریت کنید.",
            marketplace: "فروشگاه",
            purchaseTitle: "خرید بسته اعتباری",
            quantity: "تعداد",
            packages: "بسته",
            paymentMethod: "روش پرداخت",
            unitPrice: "قیمت واحد",
            toman: "تومان",
            totalAmount: "مبلغ کل",
            totalCredits: "کل اعتبارات",
            cancel: "لغو",
            confirmPurchase: "تایید خرید",
            processingPayment: "در حال پردازش پرداخت...",
            noPackagesFound: "هیچ بسته‌ای یافت نشد",
            purchasedOn: "خریداری شده در {date}",
            usage: "استفاده",
            remaining: "باقی‌مانده",
            used: "استفاده شده",
            viewDetails: "مشاهده جزئیات",
            viewDetailsTooltip: "برای مشاهده آمار تفصیلی استفاده کلیک کنید",
            featured: "ویژه",
            apiService: "سرویس API",
            subscriptionService: "سرویس اشتراک",
            scope: "محدوده مجاز",
            validFor: "معتبر برای {days} روز",
            maxPerUser: "حداکثر {count} بسته به ازای هر کاربر",
            unavailable: "در دسترس نیست",
            purchase: "خرید",
            browsePackages: "مرور بسته‌ها",
            noPackages: "هیچ بسته‌ای یافت نشد",
            package: "بسته",
            availableModels: "مدل‌های در دسترس",
            balance: "موجودی",
            grant: "گرنت",
            maxQuantity: "حداکثر تعداد مجاز",
            packageScope: "محدوده پوشش بسته",
            valueRatioTooltip:
                "به نسبت مبلغی که پرداخت می نمایید اعتبار بیشتری دریافت می کنید",
            packageScopeTooltip:
                "لیست خدمات مجاز تحت پوشش بسته اعتباری ممکن است شامل مدل‌ها یا سرویس‌های مشخصی باشد. این بسته صرفا برای استفاده از خدمات و مدل‌های ذکر شده در لیست محدوده پوشش مجاز که در توضیحات بسته آمده است، طراحی شده است. با خرید این بسته، امکان استفاده از تخفیف برای سایر مدل‌ها یا خدماتی که خارج از محدوده پوشش هستند وجود ندارد. در صورت استفاده از خدماتی که تحت پوشش بسته نیستند، هزینه بر اساس نرخ آزاد محاسبه خواهد شد",
            agreements: {
                title: "قرارداد خرید",
                description: "لطفا جهت ادامه خرید، شرایط و ضوابط زیر را مطالعه و تایید نمایید:",
                balanceRequirement: "جهت بهره‌مندی موثر از بسته‌های اعتباری، ضروری است که موجودی کلی حساب شما مثبت باشد. در صورت صفر یا منفی شدن موجودی کلی، سرویس‌های API به طور خودکار غیرفعال خواهند شد. توصیه می‌شود حداقل مبلغ ۵۰,۰۰۰ تومان در موجودی کلی حساب خود حفظ نمایید تا ارائه سرویس بدون وقفه ادامه یابد.",
                expirationPolicy: "بسته‌های اعتباری دارای تاریخ انقضای ثابت و غیرقابل تمدید هستند. پس از انقضای تاریخ مذکور، بسته‌ها، صرف‌ نظر از اعتبارات استفاده نشده باقی‌مانده، قابل تجدید یا بازیابی نخواهند بود.",
                serviceCoverage: "هر بسته اعتباری منحصرا برای سرویس‌ها و مدل‌های مشخص‌ شده در توضیحات همان بسته قابل استفاده است. اعتبارات مذکور قابل انتقال یا استفاده برای سرویس‌ها، مدل‌ها یا ویژگی‌های دیگری که صراحتا در شرایط بسته گنجانده نشده‌اند، نمی‌باشند.",
                acceptTerms: "تمام شرایط و ضوابط فوق را مطالعه کرده و می‌پذیرم.",
                mustAcceptTerms: "جهت ادامه خرید، پذیرش شرایط و ضوابط الزامی است.",
                balanceRequirementTitle: "الزامات موجودی حساب",
                expirationPolicyTitle: "سیاست انقضای بسته",
                serviceCoverageTitle: "محدودیت پوشش سرویس",
                serviceTierLimitationTitle: "محدودیت سطح سرویس",
                serviceTierLimitation: "بسته‌های اعتباری فقط درخواست‌های API که با سطح سرویس پیش‌فرض 'استاندارد' ارسال می‌شوند را پوشش می‌دهند. اگر از سطح سرویس 'منعطف' استفاده کنید (با تنظیم service_tier=flex در درخواست‌های API)، این هزینه‌ها از اعتبار بسته کسر نخواهد شد و در عوض از موجودی کلی حساب شما کسر می‌شوند.",
            },
        },
        notificationWillBe: "اعلانات ارسال می شود به",
        thresholdsMustBeDivisibleByFive: "سطح آستانه باید بر ۵ بخش پذیر باشد",
        thresholdsMustBeLeast: "حداقل سطح مجاز آستانه ",
        creditNotificationSaved: "تنظیمات ذخیره شد",
        additionalRecipientsDescription:
            "اعلانات به آدرس ایمیل و شماره تلفن ثبت شده در حساب کاربری ارسال می گردد، با این حال اگر نیاز دارید تا اعلانات به دیگر شماره تلفن یا آدرس‌های ایمیل نیز ارسال شوند میتوانید آنها را در زیر اضافه نمایید.",
        addUpToTwoEmailsAndPhones:
            "تا ۲ ایمیل و شماره تلفن دیگر را میتوانید جهت دریافت اعلانات ثبت نمایید",
        additionalRecipients: "دیگر دریافت کنندگان",
        notificationThresholds: "سطوح آستانه اعلانات",
        receiveAlertsWhen:
            "زمانی که اعتبار حساب کاربری به یکی از سطوح آستانه برسد، اطلاع رسانی می شود",
        creditNotificationSettings: "تنظیمات اعلانات اعتبار",
        packageBalanceWarning: {
            title: "هشدار موجودی بسته اعتباری",
            message: "شما بسته‌های اعتباری فعال دارید، اما موجودی عمومی حساب شما صفر یا منفی است. سرویس‌های API به طور خودکار غیرفعال می‌شوند تا زمانی که حساب خود را شارژ کنید.",
            requirement: "برای استفاده از بسته‌های اعتباری و فعال نگه داشتن کلیدهای API، موجودی عمومی مثبت الزامی است.",
            action: "همین الان حساب خود را شارژ کنید تا سرویس‌های API دوباره فعال شوند.",
            rechargeButton: "شارژ حساب"
        },
        loadingCreditNotificationSettings: "در حال دریافت تنظیمات",
        creditNotificationDisabled: "اعلانات کاهش اعتبار غیر فعال است",
        creditNotificationAt: "اعلان اعتبار در این سطوح آستانه فعال است",
        creditNotification: "اعلانات اعتبار",
        rateExpired: "تراکنش دیگر معتبر نیست",
        clickRefreshToUpdate: "لطفا دوباره تلاش کنید",
        refreshRate: "تازه‌سازی",
        amountMustBePositive: "مقدار ورودی نمیتواند منفی باشد",
        invalidExchangeAmount: "مقادیر ورودی معتبر نمی باشند",
        invalidExchangeParameters: "موارد مورد تبدیل نامعتبر هستند",
        exchangeReviewFailed: "خطایی رخ داد، لطفا دوباره تلاش کنید",
        error: "خطا",
        exchangeSuccessful: "تبدیل با موفقیت انجام شد",
        exchangeFailedUnknown: "تراکنش با خطا مواجه شد",
        exchangeValidationFailed: "صحت تراکنش تایید نشد",
        unauthorizedExchange: "تراکنش رد شد",
        tooManyRequests:
            "تعداد درخواست بیش از حد مجاز، لطفا چند لحظه بعد تلاش کنید",
        tooManyRequestsDesc: "",
        exchangeFailed: "تراکنش ناموفق",
        refreshDataFailed: "اطلاعات دریافت نشد",
        totalPaidInUnitTooltip:
            "نمایش مجموع کل اعتبارات افزایش یافته از طریق پرداخت بانکی به حساب کاربری (بر حسب UNIT)  از زمان ایجاد آن. محاسبه هر بار شارژ بر مبنای نرخ تبدیل در زمان خرید انجام شده است، نه نرخ تبدیل کنونی.",
        totalPaidInUnit: "مجموع پرداختی معادل واحد",
        historyAmount: "مبلغ پرداختی",
        paymentId: "شناسه",
        trackingCode: "کد رهگیری",
        paymentStatusFailed: "بررسی وضعیت تراکنش با خطا مواجه شد",
        paymentStatusUpdated: "وضعیت تراکنش بررسی شد",
        totalAmount: "مبلغ کل",
        pendingTransactions: "تراکنش‌های درحال تایید",
        confirmedTransactions: "تراکنش‌های تایید شده",
        selectStatus: "انتخاب وضعیت",
        selectItemType: "انتخاب نوع تراکنش",
        paymentHistory: "تاریخچه پرداخت",
        totalTransactions: "مجموع تراکنش‌ها",
        purchaseItem: "نوع",
        subscription: "اشتراک",
        credit: "اعتبار",
        confirmationDate: "تاریخ تایید",
        paidAmount: "مبلغ پرداختی",
        discount: "تخفیف",
        howToUseApi1:
            "دریافت مانده اعتبار از طریق API",
        sampleOutput: "پاسخ نمونه:",
        howToUseApi2:
            "توضیحات: remaining_irt معادل «باقی مانده اعتبار تومانی» و remaining_unit معادل «باقی مانده اعتبار تبدیل شده به واحد (نرخ تتر)» و exchange_rate نرخ تبدیل لحظه‌ای و در نهایت total_unit معادل تمام اعتبارها از جمله اعتبار افزایش یافته از طریق پرداخت بانکی، اعتبار هدیه، گرنت و ... بر مبنای نرخ تبدیل لحظه‌ای است. مقدار total_unit ملاک سنجش است.",
        exhausted: "مصرف شده",
        remainingDays: "روزهای باقی‌ مانده",
        remainingHours: "ساعات باقی مانده",
        remainingMinutes: "دقایق باقی مانده",
        remaining: "باقی مانده",
        expiration: "انقضا",
        grantsTotalUnit: "مجموع اعتبار هدیه معادل واحد",
        unnamedGrant: "بدون عنوان",
        grants: "اعتبار هدیه",
        exchangeRateUSDT: "نرخ مبادله تتر",
        fee: "کارمزد",
        timesUp: "تراکنش دیگر معتبر نیست.",
        reviewValidTill: "مقادیر پیش نمایش تا",
        secondsValidAst: "ثانیه دیگر معتبر است.",
        exchangeTo: "مقدار نهایی",
        exchangeFrom: "تبدیل از",
        exchangeRate: "نرخ تبدیل",
        feeAmount: "کارمزد",
        shortDesc1: "مدیریت و بررسی جزئیات اعتبار حساب کاربری.",
        title: "مدیریت مالی",
        topup: "افزایش اعتبار",
        minAmount: "حداقل",
        maxAmount: "حداکثر",
        IRI: "ریال",
        IRT: "تومان",
        UNIT: "واحد اعتبار",
        total: "مجموع اعتبار به واحد",
        recharge: "افزایش اعتبار",
        confirm: "تایید",
        and: "و",
        pay: "پرداخت",
        remaningCredit: "اعتبار باقی مانده",
        zero: "صفر",
        remainingCredit: "اعتبار باقی مانده",
        remainingCreditTotalUnit: "مجموع اعتبار باقی‌ مانده معادل واحد",
        noCredits: "بدون اعتبار",
        sourceAmount: "از",
        targetAmount: "به مبلغ",
        amount: "مبلغ",
        exchange: "تبدیل",
        exchangeTitle: "تبدیل اعتبار",
        confirmAndExchange: "تایید و تبدیل",
        close: "بازگشت",
        exchangeConfirmFailed: "تبدیل با خطا مواجه شد.",
        exchangeConfirmed: "تبدیل با موفقیت انجام شد",
        totalCost: "هزینه کل",
        loginToViewCredit:
            "برای مشاهده موجودی واقعی اعتبار و تاریخچه تراکنش‌ها وارد شوید",
    },
    // descriptionXs:
    //   'به مدت یک سال از تاریخ دعوت، ۱۰ درصد از فروش بسته «پلاس» و ۱ درصد از هزینه‌های api را دریافت نمایید!',
    // descriptionXs:
    //   'به مدت یک سال از تاریخ دعوت، ۱۰ درصد از فروش اشتراک «پلاس» را دریافت نمایید! همچنین دوستان شما در اولین خرید ۱۵ درصد تخفیف خواهند گرفت!',
    affiliate: {
        stepsTitle: "همکاری در فروش خود را همین حالا شروع کنید",
        stepsDescription: "این مراحل ساده را دنبال کنید تا شروع به کسب درآمد کنید",
        step1Title: "کد دعوت خود را دریافت کنید",
        step1Description: "کد دعوت ویژه شما آماده اشتراک‌گذاری است",
        step1Description2: "برای دریافت کد خود وارد شوید",
        step2Title: "دوستان را دعوت کنید",
        step2Description: "کد دعوت خود را با دوستان و همکاران به اشتراک بگذارید",
        step2Description2:
            "وقتی آنها با استفاده از کد شما ثبت‌نام می‌کنند، هر دوی شما مزایا دریافت می‌کنید!",
        step3Title: "پاداش کسب کنید",
        step3Description:
            "برای هر تراکنشی که دعوت‌شدگان شما انجام می‌دهند، کمیسیون دریافت کنید",
        step3Description2: "درآمد خود را همین‌جا در این صفحه پیگیری کنید!",
        title: "همکاری در فروش",
        descriptionLg:
            "با همکاری در بازاریابی و معرفی AvalAI به دوستان خود از طریق لینک مقابل، در درآمد فروش سهیم شده و کسب درآمد کنید.",
        descriptionXs:
            "به مدت یک سال از تاریخ دعوت، ۱۰ درصد از فروش اشتراک «پلاس» را دریافت نمایید!",
        totalUsers: "مجموع دعوت‌ها",
        usersAddedThisMonth: "دعوت‌های این ماه",
        totalIncomeThisMonth: "درآمد این ماه",
        totalIncomeConfirmed: "درآمد کل",
        totalIncomePending: "در حال تایید",
        inWithdrawalProcess: "در حال برداشت",
        lastSettledIncome: "آخرین برداشت",
        usersInMonth: "دعوت در ماه",
        username: "نام کاربری",
        registrationDate: "تاریخ ثبت نام",
        lastTransactionDate: "آخرین تراکنش",
        confirmedCommission: "تایید شده",
        pendingCommission: "در حال تایید",
        netIncome: "درآمد کل",
        transactions: "تراکنش‌ها",
        noTransaction: "ندارد",
    },
    api: {
        couldNotFetchShowingCatched: "دریافت تنظیمات کلید با خطا مواجه شد، در حال مشاهد اطلاعات پیشین هستید.",
        loadingKeyData: "در حال دریافت تنظیمات",
        keyNotFound: "کلید API یافت نشد، درصورت بروز مشکل لطفا یک مرتبه صفحه را رفرش نمایید.",
        maxApiKeysReached:
            "حداکثر سقف مجاز تعداد کلید‌های API تکمیل شده است، لطفا پیش از ایجاد کلید جدید، کلید‌های قبلی را حذف نمایید.",
        endpointAccess: "نقاط دسترسی",
        allowedEndpoints: "نقاط دسترسی مجاز",
        allowedIntents: "مقاصد مجاز",
        allEndpointsAllowed: "تمام نقاط دسترسی‌ها مجاز است",
        allIntentsAllowed: "تمام مقاصد مجاز است",
        noEndpointsAvailable: "نقاط دسترسی موجود نیست",
        noIntentsAvailable: "مقاصد موجود نیست",
        ipFormatHelp:
            "فرمت‌های پشتیبانی شده: IPv4 (مثال: 192.168.1.1)، IPv6 و نشانه‌گذاری CIDR (مثال: 192.168.1.0/24)",
        invalidCIDRFormat: "فرمت CIDR نامعتبر",
        invalidCIDRRange: "محدوده CIDR نامعتبر (0-128)",
        invalidIPv4CIDRRange: "محدوده CIDR برای IPv4 نامعتبر (0-32)",
        invalidIPv4Address: "آدرس IPv4 نامعتبر",
        invalidIPv6Address: "آدرس IPv6 نامعتبر",
        ipExamples: "مثال‌ها",
        max256IpsWarning:
            "حداکثر تا ۲۵۶ عدد آی‌پی مجاز است، تعدادی نادیده گرفته شد",
        noUsage: "ندارد",
        budgetUsed: "مصرف",
        keyModified: "کلید با موفقیت ویرایش شد",
        apiV4RangeNumebrs: "آدرس آی‌پی باید بین ۰ تا ۲۵۵ باشد",
        noModelsAvailable: "لیست مدل‌‌ها در دسترس نیست",
        allModelsAllowed: "برای دسترسی به تمامی مدل‌ها این قسمت را خالی بگذارید",
        allowedModels: "مدل‌های مجاز",
        forever: "همیشه",
        keyExpirationDay: "مدت زمان اعتبار (روز)",
        iPRestrictions: "محدودیت‌های دسترسی IP",
        pleaseEnterValidIp: "آدرس را بصورت صحیح وارد نمایید",
        neverExpires: "هیچ وقت",
        keyExpiration: "تاریخ انقضا",
        totalBudget: "بودجه کل (واحد)",
        noLimit: "بدون محدودیت",
        monthlyBudget: "بودجه ماهانه (واحد)",
        usageLimits: "محدودیت‌های استفاده",
        ipAddressInfoFooter:
            "برای لغو محدودیت دسترسی IP، لیست را خالی بگذارید، درصورت تمایل به ایجاد محدودیت، آدرس IPv4 یا IPv6 و یا CIDR را وارد نمایید.",
        enterIpAddress: "آدرس IP را وارد نمایید",
        uploadIpTips: "بارگذاری .txt یا .csv",
        importIPs: "درون ریزی IP ها",
        securitySettings: "تنظیمات امنیتی",
        advancedSettings: "تنظیمات پیشرفته",
        deleteAllIps: "حذف تمام IP ها",
        shortDesc1: "مدیریت ایمن کلید‌های دسترسی به سرویس‌های API",
        noName: "بدون نام",
        showOnce:
            "کلید خصوصی تنها همین یک مرتبه نمایش داده میشود، لطفا قبل از بستن صفحه آن را ذخیره نمایید.",
        close: "بازگشت",
        api: "API",
        confirmRevoke: "کلید حذف شود؟",
        removeConfirmYes: "حذف کن",
        removeConfirmNo: "منصرف شدم",
        remove: "حذف",
        edit: "ویرایش",
        update: "بروزرسانی",
        guardrail: {
            performanceImpact: "تاثیر بر عملکرد",
            howActivated: "روش‌های فعال‌سازی گاردریل",
            recommendation: "توصیه ما",
            futureDevelopment: "برنامه‌های توسعه آینده",
            securityNotice: "هشدارهای امنیتی",

            // Recommendation section
            recommended: "توصیه شده",
            recommendationDesc:
                "ما قویا فعال‌سازی گاردریل‌ها را برای افزایش امنیت توصیه می‌کنیم. اگرچه این ویژگی تاخیر کمی اضافه می‌کند، اما محافظتی که ارائه می‌دهد برای اکثر کاربردها ارزشمند است. با این حال، اگر برنامه شما نیاز به حداقل تاخیر دارد و از نحوه مدیریت داده‌های خود اطمینان دارید، می‌توانید این ویژگی را غیرفعال کنید.",

            // Performance impact section
            latencyImpact:
                "فعال‌سازی گاردریل‌ها یک مرحله پیش‌پردازش اضافه می‌کند که بسته به حجم و پیچیدگی داده‌های ورودی، تاخیر درخواست را حدود ۲۰۰ تا ۳۰۰۰ میلی‌ثانیه افزایش می‌دهد.",
            latencyTooltip: "تاثیر تاخیر بر اساس اندازه و پیچیدگی درخواست متغیر است",
            disableForLowLatency:
                "اگر برنامه شما نیاز به حداقل تاخیر دارد و اطمینان دارید که هیچ داده حساسی ارسال نمی‌شود، می‌توانید این ویژگی را برای کاهش سربار غیرفعال کنید.",

            detectSecrets: "detect-secrets",
            title: "تنظیمات گاردریل",
            description: "محافظت از درخواست‌های API با سیستم گاردریل",
            enabled: "گاردریل فعال است",
            disabled: "گاردریل غیرفعال است",
            explanation: "توضیحات گاردریل",
            explanationTitle: "نحوه محافظت گاردریل‌ها",
            explanationContent:
                "گاردریل‌ها از درخواست‌های API شما با شناسایی و پاکسازی اطلاعات حساس مانند کلیدهای API و توکن‌ها محافظت می‌کنند. هنگامی که این سیستم فعال باشد، تمامی درخواست‌های API پیش از رسیدن به مدل‌های LLM، توسط سیستم detect-secrets بررسی شده و اطلاعات حساس با عبارت [REDACTED] جایگزین می‌شوند.",

            currentImplementation: "پیاده‌سازی فعلی",
            implementationDetails:
                'در حال حاضر، سیستم گاردریل ما از <strong>{0}</strong> بهره می‌برد که بر مبنای پروژه متن‌باز <a href="{1}" target="_blank" rel="noopener">Yelp/detect-secrets</a> طراحی شده است. این سیستم برای شناسایی و پاکسازی داده‌های حساس مانند کلیدهای API و توکن‌ها در درخواست‌های شما استفاده می‌شود.',
            redactionProcess:
                "زمانی که گاردریل اطلاعات حساس را تشخیص می‌دهد، به صورت خودکار آن‌ها را با عبارت <code>[REDACTED]</code> جایگزین می‌کند. این فرآیند پیش از رسیدن درخواست به مدل‌های LLM انجام می‌شود و هیچ اثری از داده‌های حساس باقی نمی‌گذارد، که این امر لایه امنیتی اضافی برای محافظت از اطلاعات شما فراهم می‌کند.",

            userLevelTitle: "فعال‌سازی در سطح حساب کاربری",
            userLevelDesc:
                "با فعال‌سازی گاردریل در تنظیمات حساب کاربری، تمامی درخواست‌های API شما به طور خودکار اسکن و محافظت خواهند شد",
            perRequestTitle: "فعال‌سازی برای درخواست‌های خاص",
            perRequestDesc:
                'با قرار دادن <code>guardrails: ["hide-secrets"]</code> در داده‌های درخواست API، می‌توانید گاردریل را برای همان درخواست فعال کنید، حتی اگر در تنظیمات حساب کاربری غیرفعال باشد',

            futureDesc:
                "در حال حاضر، امکان تعریف گاردریل‌های سفارشی برای کاربران وجود ندارد. با این حال، ما در نظر داریم در به‌روزرسانی‌های آینده، این سیستم را با ویژگی‌های امنیتی پیشرفته‌تر و گزینه‌های شخصی‌سازی بیشتر، ارتقا دهیم.",

            securityDesc:
                "هرچند سیستم گاردریل یک لایه امنیتی اضافی برای محافظت از داده‌های شما فراهم می‌کند، اما تضمینی برای شناسایی تمامی اطلاعات حساس وجود ندارد. کارایی این سیستم به قابلیت‌های پروژه detect-secrets بستگی دارد. توصیه می‌کنیم همچنان اصول امنیتی را رعایت کرده و تا حد امکان، از ارسال اطلاعات حساس در درخواست‌های API خود خودداری نمایید.",
        },
        editSecretKey: "ویراش کلید API",
        editingSecretKey: "در حال ویراش کلید API",
        cancel: "لغو",
        createNewSecret: "ایجاد کلید جدید",
        cName: "نام",
        cSecret: "کلید رمز",
        cCreated: "تاریخ ایجاد",
        cLastUsed: "آخرین استفاده",
        cActions: "عملیات",
        title: "کلید‌های دسترسی API",
        editKey: "ویرایش کلید",
        createKey: "ساخت کلید API",
        keyName: "نام",
        keyNamePlaceholder: "کلید آزمایشی",
        createNewKey: "ایجاد کلید جدید",
        maskedKeysShown: "کلیدهای API رمز شده شما در زیر فهرست شده اند.",
        howToUse1:
            "برای استفاده در بسته‌های رسمی OpenAI کافیست base_url را به مقدار https://api.avalai.ir/v1 تنظیم نمایید. ",
        howToUse2: "راهنمای استفاده از کلید‌های API پلتفرم AvalAI",
        konid: "مراجعه کنید.",
        info2:
            "کلید API خود را با دیگران به اشتراک نگذارید، برای حفظ امنیت، کلید‌های جدید تنها یک مرتبه نمایش داده می‌شوند.",
        howToUse3:
            "از کتابخانه‌ها/چهارچوب‌های رسمی OpenAI استفاده کنید، یا در صورت استفاده از درخواست‌های HTTP، ساختار OpenAI را رعایت نمایید.",
        propagatingKey: "در حال انتشار در شبکه",
        propagationMessage: "کلید API در حال انتشار در شبکه است، معمولا کمتر از ۳۰ ثانیه طول می کشد.",
        propagationStatus: "همگام سازی در شبکه ...",
    },
    summary: {
        requests: "فراخوانی‌ها",
        noUsageDataTooltip:
            "هیچ داده‌ای برای نمایش موجود نیست. به محض ثبت داده‌ها، در اینجا نمایش داده خواهند شد",
        remainingCredit: "اعتبار باقی‌مانده",
        totalTokens: "مجموع توکن‌ها",
        totalRequests: "مجموع درخواست‌ها",
        remainingCreditUnit: "باقی‌مانده (واحد)",
        remainingCreditIrt: "باقی‌مانده (تومان)",
        usageTrends: "روند مصرف",
        last7Days: "۷ روز گذشته",
        last28Days: "۲۸ روز گذشته",
        modelTokenDistribution: "توزیع توکن مدل",
        dailyRequests: "درخواست‌های روزانه",
        topModelsUsage: "مدل‌های پر استفاده",
        hourlyUsageTokens: "میزان توکن ساعتی",
        hourlyUsageRequests: "درخواست‌های ساعتی",
        period1Hour: "ساعت گذشته",
        period6Hours: "۶ ساعت گذشته",
        period12Hours: "۱۲ ساعت گذشته",
        period24Hours: "۲۴ ساعت گذشته",
        cost: "هزینه",
        inputTokens: "توکن‌های ورودی",
        outputTokens: "توکن‌های خروجی",
        activeGrants: "گرنت‌های فعال",
        expiresIn: "منقضی می‌شود تا",
        days: "روز دیگر",
        recentTransactions: "تراکنش‌های اخیر",
        currency: "واحد پول",
        modelTokenUsage: "استفاده توکن مدل",
        last1Hour: "۱ ساعت گذشته",
        last6Hours: "۶ ساعت گذشته",
        last12Hours: "۱۲ ساعت گذشته",
        last24Hours: "۲۴ ساعت گذشته",
        dailyTrendNotAvailable:
            "نمودار روند مصرف روزانه برای دوره‌های ۷ روزه و ۲۸ روزه در دسترس است.",
        totalCost: "هزینه کل",
    },
    error: { fetchFailed: "دریافت ناموفق بود" },
    system: {
        title: "AvalAI",
    },
    common: {
        to: "به",
        input: "ورودی",
        output: "خروجی",
        remainingTime: "زمان باقی مانده",
        at: "در",
        allTiers: "تمام سطوح",
        allModels: "تمام مدل‌ها",
        outof: "از",
        days: "روز",
        hours: "ساعت",
        minutes: "دقیقه",
        moreItems: "مورد دیگر",
        tiers: "سطوح دسترسی",
        models: "مدل‌",
        discountOff: "ارزان‌تر",
        discount: "تخفیف",
        fetchFailed: "دریافت اطلاعات ناموفق بود",
        sort: "مرتب‌سازی",
        tier: "سطح",
        copy: "کپی",
        projectUpdates: "آخرین تغییرات",
        viewAll: "مشاهده همه",
        readMore: "مشاهده",
        loadMore: "نمایش بیشتر",
        noResults: "چیزی پیدا نشد",
        resultsFoundInOtherTabs: "نتیجه در سربرگ‌های دیگر یافت شد",
        noResultsInCurrentTab: "نتیجه‌ای در این سربرگ پیدا نشد",
        and: "و",
        additionalPersianOnly: "دیگر",
        additionalEnglishOnly: "",
        additional: "دیگر",
        emailAddress: "آدرس ایمیل",
        phoneNumber: "شماره تلفن",
        fetchError: "دریافت اطلاعات با خطا مواجه شد",
        tier1AndAbove: "سطح ۱ به بالا",
        tier3AndAvove: "سطح ۳ به بالا",
        tier5Only: "سطح کاربری ۵",
        requiresTier1: "این قابلیت در سطح کاربری ۱ به بالا در دسترس است",
        requiresTier3:
            "تعریف سطح آستانه سفارشی در سطح کاربری ۳ به بالا در دسترس است",
        requiresTier5:
            "تعریف دریافت کنندگان بیشتر، تنها در سطح کاربری ۵ در دسترس است",
        fixErrorsBeforeSaving: "قبل از ذخیره سازی لطفا خطاها را رفع کنید",
        failedToSaveSettingsTryAgain:
            "ذخیره تغییرات با خطا مواجه شد، لطفا دوباره تلاش کنید",
        equivalent: "معادل",
        manage: "مدیریت",
        threshold: "آستانه",
        saveChanges: "ذخیره تغییرات",
        saving: "در حال ذخیره",
        phone: "شماره تلفن",
        email: "آدرس ایمیل",
        recipients: "دریافت کنندگان",
        thresholds: "سطوح آستانه",
        custom: "سفارشی",
        default: "پیش فرض",
        retry: "تلاش مجدد",
        pageLoading: "در حال بارگذاری صفحه...",
        pageLoadError: "خطا در بارگذاری صفحه",
        pageLoadErrorDesc: "هنگام بارگذاری این صفحه خطایی رخ داد. لطفا دوباره تلاش کنید.",
        useInApi: "استفاده از API",
        seconds: "ثانیه",
        docs: "مستندات",
        learnMore: "بیشتر بیاموزید",
        save: "ذخیره",
        select: "انتخاب",
        comingSoon: "به زودی",
        attach: "ضمیمه",
        back: "بازگشت",
        clickToCopy: "کپی کنید",
        disabled: "غیرفعال",
        enabled: "فعال",
        hide: "مخفی کردن",
        configure: "تنظیم کردن",
        show: "نمایش",
        systemStatus: "وضعیت سرویس",
        page: "صفحه",
        total: "تعداد کل",
        showLess: "نمایش نده",
        showMore: "نمایش بیشتر",
        // noDataToDownload: 'اطلاعاتی وحود ',
        downloadError: "بارگذاری با خطا مواجه شد",
        downloadSuccess: "بارگذاری انجام شد",
        downloadCSV: "فایل CSV",
        downloadExcel: "فایل Excel",
        download: "بارگذاری",
        api: "API",
        credit: "اعتبار",
        subscription: "اشتراک",
        recheck: "بررسی",
        nothingFound: "چیزی یافت نشد",
        time: "زمان",
        date: "تاریخ",
        somethingWentWrongRefreshPage:
            "خطایی رخ داد، لطفا پس از چند لحظه مجدد تلاش کنید",
        shortCuts: "میانبرها",
        phoneAlreadyVerified:
            "شماره تلفن با موفقیت تایید شده، بروزرسانی خودکار صفحه تا چند لحظه دیگر",
        phoneVerificationRequired:
            "جهت دسترسی به سرویس‌ها، نیاز به ثبت شماره تلفن است، لطفا شماره تلفن خود را تایید کنید.",
        backToChat: "صفحه گفتگوها",
        copied: "کپی شد",
        copyFailed: "خطایی رخ داد",
        optional: "اختیاری",
        action: "عملیات",
        add: "افزودن",
        addSuccess: "افزودن با موفقیت انجام شد",
        backToHome: "بازگشت به خانه",
        batchDelete: "حذف دسته جمعی",
        cancel: "لغو",
        close: "بستن",
        check: "بررسی",
        columnSetting: "تنظیمات ستون",
        config: "پیکربندی",
        confirm: "تایید",
        delete: "حذف",
        deleteSuccess: "حذف با موفقیت انجام شد",
        confirmDelete: "می خواهید حذف کنید؟",
        edit: "ویرایش",
        index: "فهرست",
        keywordSearch: "لطفا کلیدواژه را وارد کنید",
        logout: "خروج",
        logoutConfirm: "می خواهید از حساب کاربری خارج شوید؟",
        lookForward: "به زودی",
        modify: "تغییر دادن",
        modifySuccess: "تغییر با موفقیت انجام شد",
        noData: "بدون داده",
        operate: "عملیات",
        pleaseCheckValue: "لطفا مقدار را بررسی کنید",
        refresh: "تازه‌سازی",
        reset: "تنظیم مجدد",
        search: "جستجو",
        switch: "تغییر",
        tip: "نکته",
        trigger: "رونده",
        update: "بروزرسانی",
        updateSuccess: "بروزرسانی با موفقیت انجام شد",
        userCenter: "مرکز کاربری",
        yesOrNo: {
            yes: "بله",
            no: "خیر",
        },
        newsCategories: {
            announcement: "اعلان",
            api: "API",
            models: "مدل‌ها",
            performance: "عملکرد",
            billing: "صورتحساب",
            security: "امنیت",
            feature: "قابلیت",
            documentation: "مستندات",
            tutorial: "آموزش",
            release: "انتشار",
        },
        noUpdates: "هیچ به‌روزرسانی موجود نیست",
    },
    request: {
        logout: "کاربر بعد از درخواست ناموفق خارج شود",
        logoutMsg: "وضعیت کاربر نامعتبر است، لطفا مجددا وارد شوید",
        logoutWithModal:
            "پنجره بازشو بعد از درخواست ناموفق ظاهر شود و سپس کاربر خارج شود",
        logoutWithModalMsg: "وضعیت کاربر نامعتبر است، لطفا مجددا وارد شوید",
        refreshToken: "توکن درخواست شده منقضی شده است، توکن را تازه کنید",
        tokenExpired: "توکن درخواست شده منقضی شده است",
    },
    theme: {
        themeSchema: {
            title: "طرح تم",
            light: "روشن",
            dark: "تیره",
            auto: "دنبال کردن سیستم",
        },
        layoutMode: {
            title: "حالت چیدمان",
            vertical: "حالت منوی عمودی",
            horizontal: "حالت منوی افقی",
            "vertical-mix": "حالت منوی عمودی مخلوط",
            "horizontal-mix": "حالت منوی افقی مخلوط",
        },
        themeColor: {
            title: "رنگ تم",
            primary: "اصلی",
            info: "اطلاعات",
            success: "موفقیت",
            warning: "هشدار",
            error: "خطا",
            followPrimary: "دنبال کردن رنگ اصلی",
        },
        scrollMode: {
            title: "حالت پیمایش",
            wrapper: "پوشش",
            content: "محتوا",
        },
        page: {
            animate: "انیمیشن صفحه",
            mode: {
                title: "حالت انیمیشن صفحه",
                fade: "محو شدن",
                "fade-slide": "کشیدن",
                "fade-bottom": "محو زوم",
                "fade-scale": "مقیاس محو",
                "zoom-fade": "محو زوم",
                "zoom-out": "زوم خروج",
                none: "هیچ",
            },
        },
        fixedHeaderAndTab: "سربرگ و تب ثابت",
        header: {
            height: "ارتفاع سربرگ",
            breadcrumb: {
                visible: "نمایش خرده نان",
                showIcon: "نمایش آیکون خرده نان",
            },
        },
        tab: {
            visible: "نمایش برگه",
            cache: "کش برگه",
            height: "ارتفاع برگه",
            mode: {
                title: "حالت برگه",
                chrome: "کروم",
                button: "دکمه",
            },
        },
        sider: {
            inverted: "کناری تیره",
            width: "عرض کناری",
            collapsedWidth: "عرض کناری فشرده",
            mixWidth: "عرض کناری مخلوط",
            mixCollapsedWidth: "عرض کناری فشرده مخلوط",
            mixChildMenuWidth: "عرض منوی فرزند مخلوط",
        },
        footer: {
            visible: "پاورقی نمایش داده شده",
            fixed: "پاورقی ثابت",
            height: "ارتفاع پاورقی",
            right: "پاورقی سمت راست",
        },
        themeDrawerTitle: "پیکربندی تم",
        pageFunTitle: "کارکرد صفحه",
        configOperation: {
            copyConfig: "کپی پیکربندی",
            copySuccessMsg:
                "کپی موفق، لطفا متغیر themeSettings را در src/theme/settings.ts جایگزین کنید",
            resetConfig: "تنظیم مجدد پیکربندی",
            resetSuccessMsg: "تنظیم مجدد موفق",
        },
    },
    route: {
        // "support_knowledge-base": "پایگاه دانش",
        // support: "پشتیبانی",
        // support_dashboard: "داشبورد",
        // "support_create-ticket": "ایجاد تیکت",
        // "support_my-tickets": "تیکت‌های من",
        // "support_all-tickets": "همه تیکت‌ها",
        // "support_ticket-details": "جزئیات تیکت",
        models: "مدل‌ها",
        // assistants: "دستیارها",
        // storage: "فضای ذخیره‌سازی",
        billing_history: "تاریخچه",
        usage_reports: "‌گزارش‌ها",
        usage_overview: "نمایش",
        billing_credit: "اعتبار",
        billing_packages: "بسته‌ها",
        affiliate: "کسب درآمد",
        usage: "مصارف",
        limits: "سطح دسترسی",
        billing: "مالی",
        "api-keys": "کلید‌های API",
        login: "ورود",
        403: "بدون اجازه",
        404: "صفحه یافت نشد",
        500: "خطای سرور",
        home: "پیشخان",
        // docs: 'مستندات',
        // "docs_whats-new": "تازه‌های سیستم",
        // docs_vision: "بینایی ماشین",
        // "docs_text-to-speech": "تبدیل متن به گفتار",
        // "docs_text-generation": "تولید متن",
        // "docs_structured-outputs": "خروجی‌های ساختاریافته",
        // "docs_speech-to-text": "تبدیل گفتار به متن",
        // "docs_safety-best-practices": "بهترین شیوه‌های امنیتی",
        // docs_reasoning: "استدلال و منطق",
        // "docs_release-notes": "یادداشت‌های انتشار",
        // "docs_realtime-websocket": "یکپارچه‌سازی وب‌سوکت",
        // "docs_realtime-webrtc": "یکپارچه‌سازی WebRTC",
        // "docs_realtime-model-capabilities": "قابلیت‌های مدل بلادرنگ",
        // docs_realtime: "ویژگی‌های بلادرنگ",
        // "docs_rate-limits": "محدودیت‌های نرخ درخواست",
        // docs_quickstart: "راهنمای شروع سریع",
        // "docs_prompt-generation": "تولید پرامپت",
        // "docs_prompt-examples": "نمونه‌های پرامپت",
        // "docs_prompt-engineering": "مهندسی پرامپت",
        // "docs_prompt-caching": "کش‌کردن پرامپت",
        // "docs_production-best-practices": "بهترین شیوه‌های تولید",
        // "docs_predicted-outputs": "خروجی‌های پیش‌بینی شده",
        // docs_overview: "نمای کلی",
        // "docs_optimizing-llm-accuracy": "بهینه‌سازی دقت LLM",
        // docs_moderation: "نظارت بر محتوا",
        // docs_models: "مدل‌ها",
        // "docs_model-selection": "راهنمای انتخاب مدل",
        // docs_libraries: "کتابخانه‌ها و SDK‌ها",
        // "docs_latency-optimization": "بهینه‌سازی تاخیر",
        // "docs_image-generation": "تولید تصویر",
        // "docs_function-calling": "فراخوانی توابع",
        // "docs_fine-tuning": "تنظیم دقیق مدل‌ها",
        // docs_evals: "ارزیابی مدل‌ها",
        // "docs_error-codes": "کدهای خطا",
        // docs_distillation: "تقطیر مدل",
        // docs_embeddings: "جاسازی‌ها",
        // docs_deprecations: "اعلان‌های منسوخ شدگی",
        // "docs_deep-dive": "بررسی عمیق فنی",
        // docs_changelog: "تاریخچه تغییرات",
        // docs_batch: "پردازش دسته‌ای",
        // docs_assistant_usage: "راهنمای استفاده از دستیار",
        // docs_assistant_tools: "ابزارهای دستیار",
        // docs_assistant_quickstart: "شروع سریع دستیار",
        // "docs_audio-generation": "تولید صدا",
        // "docs_assistant_whats-new": "به‌روزرسانی‌های دستیار",
        // docs_assistant_overview: "نمای کلی دستیار",
        // docs_assistant_tools_overview: "نمای کلی ابزارها",
        // "docs_assistant_tools_function-calling": "ابزارهای فراخوانی توابع",
        // "docs_assistant_tools_file-search": "ابزارهای جستجوی فایل",
        // "docs_assistant_tools_code-interpreter": "مفسر کد",
        // docs_assistant_migration: "راهنمای مهاجرت دستیار",
        // docs_assistant: "دستیار هوش مصنوعی",
        // "docs_assistant_deep-dive": "جزئیات فنی دستیار",
        // "docs_advanced-usage": "استفاده پیشرفته",
        // "docs_actions_sending-files": "ارسال فایل با اکشن‌ها",
        // docs_actions_production: "اکشن‌ها در محیط تولید",
        // docs_actions_introduction: "معرفی اکشن‌ها",
        // docs: "مستندات",
        // "docs_accuracy-optimization": "بهینه‌سازی دقت",
        // docs_actions: "اکشن‌ها",
        // "docs_actions_actions-library": "کتابخانه اکشن‌ها",
        // "docs_actions_data-retrieval": "اکشن‌های بازیابی داده",
        // docs_actions_authentication: "احراز هویت اکشن‌ها",
        // "docs_actions_getting-started": "شروع کار با اکشن‌ها",
        // 'user-center': 'مرکز کاربری',
        // about: 'درباره',
        // function: 'کارکرد سیستم',
        // function_tab: 'برگه',
        // 'function_multi-tab': 'برگه چندگانه',
        // 'function_hide-child': 'پنهان کردن فرزند',
        // 'function_hide-child_one': 'پنهان کردن فرزند',
        // 'function_hide-child_two': 'دو',
        // 'function_hide-child_three': 'سه',
        // function_request: 'درخواست',
        // 'function_toggle-auth': 'تغییر مجوز',
        // 'function_super-page': 'قابل مشاهده مدیر فوق العاده',
        // manage: 'مدیریت سیستم',
        // manage_user: 'مدیریت کاربر',
        // 'manage_user-detail': 'جزئیات کاربر',
        // manage_role: 'مدیریت نقش',
        // manage_menu: 'مدیریت منو',
        // 'multi-menu': 'منوی چندگانه',
        // 'multi-menu_first': 'منوی یک',
        // 'multi-menu_first_child': 'فرزند منوی یک',
        // 'multi-menu_second': 'منوی دو',
        // 'multi-menu_second_child': 'فرزند منوی دو',
        // 'multi-menu_second_child_home': 'خانه فرزند منوی دو',
        exception: "استثنا",
        exception_403: "403",
        exception_404: "404",
        exception_500: "500",
    },
    page: {
        login: {
            common: {
                // visitAsGuest: 'ورود بصورت مهمان',
                login: "ورود به سیستم",
                needLogin: "برای دسترسی به این صفحه نیاز است ابتدا وارد شوید",
                continueAsGuest: "ادامه به عنوان مهمان",
                loginBenefits: "برای دسترسی کامل به داشبورد خود وارد شوید",
                unlockFeatures: "با ورود به سیستم دسترسی پیدا کنید:",
                loginRequired: "برای دسترسی کامل به داشبورد خود وارد شوید",
                loginOrRegister: "ورود / ثبت نام",
                userNamePlaceholder: "لطفا نام کاربری را وارد کنید",
                phonePlaceholder: "لطفا شماره تلفن را وارد کنید",
                codePlaceholder: "لطفا کد تایید را وارد کنید",
                passwordPlaceholder: "لطفا رمز عبور را وارد کنید",
                confirmPasswordPlaceholder: "لطفا رمز عبور را دوباره وارد کنید",
                codeLogin: "ورود با کد تایید",
                confirm: "تایید",
                back: "بازگشت",
                validateSuccess: "تایید موفق",
                loginSuccess: "ورود موفقیت آمیز",
                welcomeBack: "خوش آمدید, {userName} !",
                benefits: {
                    "api-keys": {
                        a: "ایجاد و مدیریت کلیدهای API",
                        b: "نظارت بر استفاده و هزینه‌های API",
                        c: "تنظیم محدودیت‌های نرخ و مجوزها",
                    },
                    billing: {
                        a: "مشاهده تاریخچه تفصیلی صورتحساب",
                        b: "افزودن اعتبار به حساب کاربری",
                        c: "دانلود فاکتورها و رسیدها",
                    },
                    packages: {
                        a: "مشاهده و مدیریت بسته‌های اعتبار",
                        b: "خرید بسته‌های اعتباری جدید",
                        c: "مشاهده تاریخچه بسته‌های اعتباری خریداری شده",
                    },
                    home: {
                        a: "دسترسی به داشبورد شخصی‌سازی شده",
                        b: "مشاهده داده‌های استفاده در زمان واقعی",
                        c: "سفارشی‌سازی تنظیمات و ترجیحات",
                    },
                    models: {
                        a: "دسترسی به تمام مدل‌های موجود",
                        b: "مشاهده اطلاعات تفصیلی مدل‌ها",
                        c: "مقایسه قابلیت‌های مدل‌ها",
                    },
                    usage: {
                        a: "تجزیه و تحلیل تفصیلی استفاده",
                        b: "صادرات گزارش‌های استفاده",
                        c: "پیگیری هزینه‌ها در طول زمان",
                    },
                    affiliate: {
                        a: "کسب درآمد از طریق معرفی",
                        b: "مشاهده کاربران معرفی شده و درآمد",
                        c: "برداشت درآمدهای کسب شده",
                    },
                },
            },
            pwdLogin: {
                title: "ورود با رمز عبور",
                rememberMe: "مرا به خاطر بسپار",
                forgetPassword: "رمز عبور را فراموش کرده اید؟",
                register: "ثبت نام",
                otherAccountLogin: "ورود با حساب کاربری دیگر",
                otherLoginMode: "حالت ورود دیگر",
                superAdmin: "مدیر فوق العاده",
                admin: "مدیر",
                user: "کاربر",
            },
            codeLogin: {
                title: "ورود با کد تایید",
                getCode: "دریافت کد تایید",
                sendFailed: "ارسال کد تایید با خطا مواجه شد، لطفا دوباره تلاش کنید",
                reGetCode: "دریافت مجدد پس از {time} ثانیه",
                sendCodeSuccess: "کد تایید با موفقیت ارسال شد",
                sendCodeSuccessViaFallback: "کد تایید از طریق {provider} ارسال شد",
                imageCodePlaceholder: "لطفا کد تایید تصویری را وارد کنید",
                codeNotValid: "کد صحیح نیست و یا منقضی شده",
                phoneAlreadyAssociated:
                    "این شماره تلفن قبلا به حساب کاربری دیگری متصل شده است.",
                phoneAlreadyAssociatedHelp:
                    "چنانچه مالک این شماره تلفن هستید، ابتدا حساب مرتبط با این شماره تلفن را از صفحه حذف حساب کاربری حذف نمایید تا شماره آزاد شود، سپس مجدد تلاش کنید.",
                deleteLinkedAccount: "باز کردن صفحه حذف حساب کاربری",
                fallbackProvider: {
                    bale: "پیام رسان بله",
                },
                fallbackProviderLink: {
                    bale: "https://web.bale.ai/",
                },
                openFallbackProvider: "باز کردن {provider}",
                fallbackOtpTitle: "روش تایید جایگزین",
                fallbackOtpWhyTitle: "چرا این را می‌بینم؟",
                fallbackOtpWhyDescription: "ما سعی کردیم کد تایید را از طریق پیامک برای شما ارسال کنیم، اما سرویس پیامک ما موقتا در دسترس نیست. برای اطمینان از اینکه همچنان می‌توانید به طور ایمن به حساب خود دسترسی داشته باشید، کد تایید شما را از طریق کانال جایگزین ارسال کرده‌ایم.",
                fallbackOtpSmsNotResponding: "سرویس پیامک در حال حاضر پاسخگو نیست. کد شما به صورت امن از طریق {provider} ارسال شده است.",
                fallbackOtpStep1: "ما سعی کردیم پیامک ارسال کنیم اما سرویس در دسترس نبود",
                fallbackOtpStep2: "کد تایید شما به صورت امن به {provider} ارسال شده است",
                fallbackOtpStep3: "کدی که دریافت کرده‌اید را وارد کنید تا تایید کامل شود",
                fallbackOtpAlternativeTitle: "ترجیح می‌دهید پیامک دریافت کنید؟",
                fallbackOtpAlternativeDescription: "اگر ترجیح می‌دهید کد تایید را از طریق پیامک دریافت کنید، می‌توانید چند دقیقه صبر کنید و دوباره امتحان کنید. سیستم ما همیشه ابتدا سعی می‌کند پیامک ارسال کند و سپس از روش‌های جایگزین استفاده می‌کند.",
                fallbackOtpRetryLater: "لطفا چند دقیقه صبر کنید و دوباره امتحان کنید. سرویس پیامک ممکن است به زودی در دسترس قرار گیرد.",
                fallbackOtpInfoButton: "چرا این روش؟",
            },
            register: {
                title: "ثبت نام",
                agreement: "من خوانده ام و موافقت می کنم با",
                protocol: "《توافق نامه کاربر》",
                policy: "《سیاست حفظ حریم خصوصی》",
            },
            resetPwd: {
                title: "بازنشانی رمز عبور",
            },
            bindWeChat: {
                title: "پیوستن به WeChat",
            },
            guestMode: {
                message: "شما به عنوان مهمان در حال مشاهده هستید. برای دسترسی کامل، لطفا وارد شوید.",
                timeRemaining: "جلسه مهمان در {time} منقضی می‌شود",
                upgradePrompt:
                    "از پلتفرم لذت می‌برید؟ حساب کاربری بسازید تا پیشرفت خود را ذخیره کنید.",
            },
            benefits: {
                createApiKeys: "[REDACTED]",
                manageKeys: "قابلیت‌های کامل مدیریت کلید",
                viewUsage: "تحلیل‌های دقیق استفاده",
                viewBilling: "دسترسی به تاریخچه صورتحساب",
                addCredits: "افزودن اعتبار و مدیریت پرداخت‌ها",
                downloadInvoices: "دانلود فاکتور و رسید",
                personalizedDashboard: "تجربه داشبورد شخصی‌سازی شده",
                realTimeData: "داده‌ها و اعلان‌های لحظه‌ای",
                customSettings: "تنظیمات و ترجیحات سفارشی",
            },
        },
        about: {
            title: "درباره",
            introduction:
                "Soybean Admin یک قالب مدیریتی زیبا و قدرتمند است که بر اساس آخرین تکنولوژی های فرانت اند ایجاد شده است، از جمله Vue3, Vite5, TypeScript, Pinia و UnoCSS. این قالب دارای پیکربندی تم غنی و اجزا ساخته شده است، مشخصات کد سختگیرانه، و سیستم مسیریابی فایل خودکار. علاوه بر این، از راه حل داده های mock آنلاین بر اساس ApiFox استفاده می کند. Soybean Admin یک راه حل مدیریتی یکپارچه برای شما فراهم می کند، بدون هیچ پیکربندی اضافی، و آماده برای استفاده. همچنین این یک روش بهترین عملکرد برای یادگیری سریع تکنولوژی های جدید است.",
            projectInfo: {
                title: "اطلاعات پروژه",
                version: "نسخه",
                latestBuildTime: "آخرین زمان ساخت",
                githubLink: "لینک Github",
                previewLink: "لینک پیش نمایش",
            },
            prdDep: "وابستگی تولید",
            devDep: "وابستگی توسعه",
        },
        home: {
            offer1: "۳۵۰ میلیون تومان",
            offer2: "۵۵۰ میلیون تومان",
            offer3: "۱ میلیارد تومان",
            offer1Benefit: "۵۰ میلیون تومان",
            offer2Benefit: "۱۰۰ میلیون تومان",
            offer3Benefit: "۲۰۰ میلیون تومان",
            specialOffer: "پیشنهاد ویژه: اعتبار رایگان تا ۲۰۰ میلیون تومان!",
            inChargeMoreGetMore:
                "با شارژ حساب خود، اعتبار رایگان دریافت کنید. هر چه بیشتر شارژ کنید، اعتبار بیشتری می‌گیرید!",
            offerExpiresIn:
                "این پیشنهاد تا ۳۱ شهریور معتبر است. اعتبار دریافتی تا ۶۰ روز قابل استفاده می‌باشد.",
            shortDesc1: "پلتفرم AvalAI ارائه‌دهنده API مدل‌های هوش مصنوعی",
            // desc1Title: 'دسترسی راحت',
            desc1:
                "با ایجاد تنها یک حساب کاربری توسعه‌دهنده در پلتفرم هوش مصنوعی AvalAI، به دنیایی از امکانات بی‌پایان و دسترسی نامحدود به تمامی خدمات پیشرو هوش مصنوعی از جمله OpenAI، Anthropic، Meta، Mistral AI، Cohere، Google (Gemini) و Deepseek بر اساس تعرفه‌های رسمی ارائه‌دهندگان دست خواهید یافت.",
            desc2:
                "دسترسی آسان به AvalAI، بدون مواجهه با محدودیت‌های ناخواسته مانند محدودیت‌های جغرافیایی، پرداخت‌های امن ریالی بدون کارمزد اضافی، فعال‌سازی فوری حساب‌های کاربری، و پایداری حداکثری زیرساخت‌های ما، همگی تضمین‌کننده تجربه‌ای لذت‌بخش برای توسعه‌دهندگان، پژوهشگران و کسب‌وکارها می‌باشد. با استفاده از پلتفرم هوش مصنوعی AvalAI، شما به راحتی می‌توانید از قابلیت‌های برترین مدل‌های هوش مصنوعی برای رشد و توسعه پروژه‌ها و ایده‌های خود بهره‌مند شوید.",
            desc3:
                "ما در AvalAI به ارائه تجربه‌ای لذت‌ بخش و کارآمد برای توسعه‌دهندگان، پژوهشگران و کسب‌وکارها متعهد هستیم. از قابلیت‌های بی نظیر AI برای ارتقای پروژه‌ها و ایده‌های خود به سطوح جدید استفاده کنید. به جمع ما در AvalAI بپیوندید و از همین امروز آینده را شکل دهید.",
            greeting: "خوش آمدید",
            weatherDesc: "امروز ابری تا صاف است, 20℃ - 25℃!",
            projectCount: "تعداد پروژه",
            todo: "کار های برنامه ریزی شده",
            message: "پیام",
            downloadCount: "تعداد دانلود",
            registerCount: "تعداد ثبت نام",
            schedule: "برنامه کار و استراحت",
            study: "مطالعه",
            work: "کار",
            rest: "استراحت",
            entertainment: "سرگرمی",
            visitCount: "تعداد بازدید",
            turnover: "دوران سرمایه",
            dealCount: "تعداد معاملات",
            projectNews: {
                title: "اخبار پروژه",
                moreNews: "اخبار بیشتر",
                desc1:
                    "Soybean در 28 می 2021 پروژه متن باز soybean-admin را ایجاد کرد!",
                desc2:
                    "یانبوو یک باگ به soybean-admin ارسال کرد، نوار multi-tab تنظیم نمی شود.",
                desc3: "Soybean در حال آماده سازی کافی برای انتشار soybean-admin است!",
                desc4: "Soybean در حال نوشتن مستندات پروژه برای soybean-admin است!",
                desc5:
                    "Soybean فقط برخی از صفحات کارگاه را به صورت تصادفی نوشت، و این کافی بود تا ببیند!",
            },
            creativity: "خلاقیت",
        },
        function: {
            tab: {
                tabOperate: {
                    title: "عملکرد برگه",
                    addTab: "افزودن برگه",
                    addTabDesc: "به صفحه درباره",
                    closeTab: "بستن برگه",
                    closeCurrentTab: "بستن برگه فعلی",
                    closeAboutTab: "",
                    addMultiTab: "افزودن برگه چندگانه",
                    addMultiTabDesc1: "به صفحه MultiTab",
                    addMultiTabDesc2: "به صفحه MultiTab (با پارامترهای query)",
                },
                tabTitle: {
                    title: "عنوان برگه",
                    changeTitle: "تغییر عنوان",
                    change: "تغییر",
                    resetTitle: "بازنشانی عنوان",
                    reset: "بازنشانی",
                },
            },
            multiTab: {
                routeParam: "پارامتر مسیر",
                backTab: "برگشت به function_tab",
            },
            toggleAuth: {
                toggleAccount: "تغییر حساب",
                authHook: "کارکرد مجوز hasAuth",
                superAdminVisible: "قابل مشاهده مدیر فوق العاده",
                adminVisible: "قابل مشاهده مدیر",
                adminOrUserVisible: "قابل مشاهده مدیر و کاربر",
            },
        },
        manage: {
            common: {
                status: {
                    enable: "فعال کردن",
                    disable: "غیر فعال کردن",
                },
            },
            role: {
                title: "لیست نقش ها",
                roleName: "نام نقش",
                roleCode: "کد نقش",
                roleStatus: "وضعیت نقش",
                roleDesc: "توضیحات نقش",
                menuAuth: "مجوز منو",
                buttonAuth: "مجوز دکمه",
                form: {
                    roleName: "لطفا نام نقش را وارد کنید",
                    roleCode: "لطفا کد نقش را وارد کنید",
                    roleStatus: "لطفا وضعیت نقش را انتخاب کنید",
                    roleDesc: "لطفا توضیحات نقش را وارد کنید",
                },
                addRole: "اضافه کردن نقش",
                editRole: "ویرایش نقش",
            },
            user: {
                title: "لیست کاربران",
                userName: "نام کاربری",
                userGender: "جنسیت",
                nickName: "نام مستعار",
                userPhone: "شماره تلفن",
                userEmail: "ایمیل",
                userStatus: "وضعیت کاربر",
                userRole: "نقش کاربر",
                form: {
                    userName: "لطفا نام کاربری را وارد کنید",
                    userGender: "لطفا جنسیت را انتخاب کنید",
                    nickName: "لطفا نام مستعار را وارد کنید",
                    userPhone: "لطفا شماره تلفن را وارد کنید",
                    userEmail: "لطفا ایمیل را وارد کنید",
                    userStatus: "لطفا وضعیت کاربر را انتخاب کنید",
                    userRole: "لطفا نقش کاربر را انتخاب کنید",
                },
                addUser: "اضافه کردن کاربر",
                editUser: "ویرایش کاربر",
                gender: {
                    male: "مرد",
                    female: "زن",
                },
            },
            menu: {
                home: "خانه",
                title: "لیست منو",
                id: "شناسه",
                parentId: "شناسه والد",
                menuType: "نوع منو",
                menuName: "نام منو",
                routeName: "نام مسیر",
                routePath: "مسیر",
                routeParams: "پارامترهای مسیر",
                layout: "کامپوننت چیدمان",
                page: "کامپوننت صفحه",
                i18nKey: "کلید بین المللی",
                icon: "آیکون",
                localIcon: "آیکون محلی",
                iconTypeTitle: "نوع آیکون",
                order: "ترتیب",
                keepAlive: "نگه داشتن زنده",
                href: "آدرس اینترنتی",
                hideInMenu: "مخفی کردن در منو",
                activeMenu: "منوی فعال",
                multiTab: "برگه های چندگانه",
                fixedIndexInTab: "شاخص ثابت در برگه",
                button: "دکمه",
                buttonCode: "کد دکمه",
                buttonDesc: "توضیح دکمه",
                menuStatus: "وضعیت منو",
                form: {
                    home: "لطفا خانه را انتخاب کنید",
                    menuType: "لطفا نوع منو را انتخاب کنید",
                    menuName: "لطفا نام منو را وارد کنید",
                    routeName: "لطفا نام مسیر را وارد کنید",
                    routePath: "لطفا مسیر را وارد کنید",
                    page: "لطفا کامپوننت صفحه را انتخاب کنید",
                    layout: "لطفا کامپوننت چیدمان را انتخاب کنید",
                    i18nKey: "لطفا کلید بین المللی را وارد کنید",
                    icon: "لطفا نام آیکون را وارد کنید",
                    localIcon: "لطفا نام آیکون محلی را وارد کنید",
                    order: "لطفا ترتیب را وارد کنید",
                    keepAlive: "لطفا انتخاب کنید که آیا مسیر کش شود یا خیر",
                    href: "لطفا آدرس اینترنتی را وارد کنید",
                    hideInMenu: "لطفا انتخاب کنید که آیا منو مخفی شود یا خیر",
                    activeMenu: "لطفا نام مسیر منوی برجسته را وارد کنید",
                    multiTab:
                        "لطفا انتخاب کنید که آیا پشتیبانی از برگه های چندگانه انجام شود یا خیر",
                    fixedInTab: "لطفا انتخاب کنید که آیا در برگه ثابت شود یا خیر",
                    fixedIndexInTab: "لطفا شاخص ثابت در برگه را وارد کنید",
                    button: "لطفا انتخاب کنید که آیا این یک دکمه است یا خیر",
                    buttonCode: "لطفا کد دکمه را وارد کنید",
                    buttonDesc: "لطفا توضیح دکمه را وارد کنید",
                    menuStatus: "لطفا وضعیت منو را انتخاب کنید",
                },
                addMenu: "اضافه کردن منو",
                editMenu: "ویرایش منو",
                addChildMenu: "اضافه کردن زیرمنو",
                type: {
                    directory: "دایرکتوری",
                    menu: "منو",
                },
                iconType: {
                    iconify: "آیکون Iconify",
                    local: "آیکون محلی",
                },
            },
        },
    },
    form: {
        required: "نمی تواند خالی باشد",
        userName: {
            required: "لطفا نام کاربری را وارد کنید",
            invalid: "فرمت نام کاربری اشتباه است",
        },
        phone: {
            required: "لطفا شماره تلفن را وارد کنید",
            invalid: "فرمت شماره تلفن اشتباه است",
        },
        pwd: {
            required: "لطفا رمز عبور را وارد کنید",
            invalid: "6-18 کاراکتر، شامل حروف، اعداد، و خط زیر",
        },
        confirmPwd: {
            required: "لطفا رمز عبور را دوباره وارد کنید",
            invalid: "دو رمز عبور یکسان نیستند",
        },
        code: {
            required: "لطفا کد تایید را وارد کنید",
            invalid: "فرمت کد تایید اشتباه است",
        },
        email: {
            required: "لطفا ایمیل را وارد کنید",
            invalid: "فرمت ایمیل اشتباه است",
        },
    },
    dropdown: {
        closeCurrent: "بستن فعلی",
        closeOther: "بستن بقیه",
        closeLeft: "بستن چپ",
        closeRight: "بستن راست",
        closeAll: "بستن همه",
    },
    icon: {
        themeConfig: "پیکربندی تم",
        themeSchema: "طرح تم",
        lang: "تغییر زبان",
        fullscreen: "تمام صفحه",
        fullscreenExit: "خروج از حالت تمام صفحه",
        reload: "بارگذاری مجدد صفحه",
        collapse: "بستن منو",
        expand: "باز کردن منو",
        pin: "سنجاق",
        unpin: "برداشتن سنجاق",
    },
    storage: {
        uploadModalTitle: "بارگذاری فایل",
        fileSelected: "فایل انتخاب شد",
        uploadFilePlaceholder: "یک فایل بارگذاری کنید یا اینجا بکشید و رها کنید",
        fileNameLabel: "نام",
        fileNameDescription: "نام فایل بارگذاری شده",
        fileNamePlaceholder: "نام فایل را وارد کنید",
        purposeLabel: "هدف",
        purposeDescription: "هدف از بارگذاری فایل",
        purposePlaceholder: "انتخاب هدف",
        learnMoreLink: "درباره اهداف فایل بیشتر بدانید",
        searchFilesPlaceholder: "جستجوی فایل‌ها ...",
        invalidFileType: "نوع فایل برای {purpose} نامعتبر است",
        supportedFormatsAssistants: "فرمت‌های پشتیبانی‌شده: {formats}",
        supportedFormatsVision: "فرمت‌های پشتیبانی‌شده: {formats}",
        supportedFormatsJsonl: "فقط فایل‌های .jsonl پشتیبانی می‌شوند.",
        fileNotFound: "فایل پیدا نشد.",
        fileUploadedButNotListed:
            "فایل بارگذاری شد، اما هنوز در لیست نمایش داده نمی‌شود.",
        fileUploadedAndListed: "فایل بارگذاری شد و در لیست تایید شد.",
        downloadStarting: "شروع دانلود...",
        downloading: "در حال دانلود...",
        downloadComplete: "دانلود کامل شد.",
        downloadError: "خطا در دانلود فایل.",
        file: "فایل",
        status: "وضعیت",
        fileId: "شناسه فایل",
        purpose: "هدف",
        size: "اندازه",
        createdAt: "تاریخ ایجاد",
        download: "دانلود",
        delete: "حذف",
        deleteConfirm: "آیا مطمئن هستید که می‌خواهید این فایل را حذف کنید؟",
        selectFile: "برای مشاهده جزئیات، یک فایل را انتخاب کنید.",
        files: "فایل‌ها",
        vectorStores: "مخازن برداری",
        upload: "بارگذاری",
        noFiles: "هنوز فایلی بارگذاری نشده است.",
        noVectorStores: "هنوز مخزن برداری ایجاد نشده است.",
        selectItem: "برای مشاهده جزئیات، یک مورد را انتخاب کنید.",
        uploadSuccess: "فایل با موفقیت بارگذاری شد",
        uploadError: "بارگذاری فایل با خطا مواجه شد",
        fileDeleted: "فایل با موفقیت حذف شد",
        deleteError: "حذف فایل با خطا مواجه شد",
        fetchError: "دریافت اطلاعات با خطا مواجه شد",
    },
    assistants: {
        vectorStore: "Vector Store",
        noAssistants: "No assistants found",
        createAssistantGetStarted:
            "Create an assistant to get started with Assistants API.",
        defineResponseSchema: "Define Response Schema",
        responseSchemaDescription:
            "Define the JSON schema for the assistant's responses",
        enterVectorStoreId: "Enter vector store Id",
        selectExisting: "Select Existing",
        uploadNew: "Upload New",
        uploadFile: "Upload File",
        generate: "Generate",
        examples: "Examples",
        getStockPrice: "Get Stock Price",
        weatherForecast: "Weather Forecast",
        calculator: "Calculator",
        functions: "Functions",
        addFunction: "Add Function",
        editFunction: "Edit Function",
        removeFunction: "Remove Function",
        functionName: "Function Name",
        functionDescription:
            "Define a function that the assistant can call. The function should be defined using JSON Schema format.",
        functionDefinitionPlaceholder:
            "    Enter function definition in JSON Schema format...",
        definition: "Function Definition",
        strictMode: "Strict Mode",
        strictModeHelp:
            "When enabled, the assistant will only call functions exactly as defined. Disable for more flexible function calling.",
        invalidDefinition:
            "Invalid function definition. Please check the JSON Schema format.",
        duplicateFunctionName: "A function with this name already exists.",
        functionRequired: "Function definition is required",
        generateFunction: "Generate Function",
        exampleFunctions: "Example Functions",
        functionSaved: "Function saved successfully",
        functionRemoved: "Function removed successfully",
        functionValidationError:
            "Function validation failed. Please check the definition.",
        learnMoreFunctions: "Learn more about function definitions",
        modelRequired: "Model is required",
        responseFormatRequired: "Response format is required",
        temperatureInvalid: "Temperature must be between 0 and 2",
        topPInvalid: "Top P must be between 0 and 1",
        maxResultsInvalid: "Max results must be within the allowed range",
        title: "Assistants",
        selectToView: "Select an assistant to view details",
        createNew: "Create New Assistant",
        name: "Name",
        namePlaceholder: "Enter a user friendly name",
        nameRequired: "Name is required",
        instructions: "Instructions",
        instructionsPlaceholder: "You are a helpful assistant...",
        instructionsRequired: "Instructions are required",
        model: "Model",
        tools: "Tools",
        fileSearch: "File Search",
        codeInterpreter: "Code Interpreter",
        addFiles: "Add Files",
        selectVectorStore: "Select Vector Store",
        modelConfig: "Model Configuration",
        responseFormat: "Response Format",
        temperature: "Temperature",
        topP: "Top P",
        maxResults: "Max Results",
        maxResultsHelp: "Maximum number of results to return from file search",
        create: "Create",
        attachFiles: "Attach Files to File Search",
        attachVectorStore: "Attach Vector Store",
        dragFilesHere: "Drag your files here",
        clickToUpload: "Click to Upload",
        fileUploadHelp:
            "Files will be processed and made available for the assistant to search through",
        vectorStoreHelp:
            "Select an existing vector store to allow the assistant to search through its contents",
        searchVectorStores: "Search vector stores...",
        noVectorStoresFound: "No vector stores found",
        vectorStoreSearchPlaceholder: "Enter vector store id",
        attach: "Attach",
        back: "Back",
        learnMore: "Learn more",
        fileName: "File Name",
        fileSize: "Size",
        fileStatus: "Status",
        fileActions: "Actions",
        removeFile: "Remove",
        fileAttached: "File attached successfully",
        vectorStoreAttached: "Vector store attached successfully",
        fileRemoved: "File removed",
        invalidFileType: "Invalid file type",
        fileTooLarge: "File is too large",
        uploadError: "Error uploading file",
        temperatureHelp: "Controls randomness in the assistant's responses",
        topPHelp: "Controls diversity of the assistant's responses",
        fileSearchHelp: "Enable searching through attached files",
        codeInterpreterHelp: "Enable Python code execution capabilities",
    },
};

export default local;
